(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-chat"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-gt-chat]');
    if (!root) return;

    const I18N    = window.GT_CHAT_I18N || {};
    const msgsEl  = root.querySelector('[data-gt-msgs]');
    const formEl  = root.querySelector('[data-gt-form]');
    const inputEl = root.querySelector('[data-gt-input]');
    const fabEl   = root.querySelector('[data-gt-fab]');
    const minBtn  = root.querySelector('[data-gt-min]');
    const closeBtn= root.querySelector('[data-gt-close]');

    const STORAGE_KEY = 'gt_chat_v2';
    // Backend proxy — POST {messages: history} → expects {reply: "..."}.
    // Reply text may embed any of:
    //   [[CTA_NEWSLETTER]]              — render inline newsletter subscribe form
    //   [[CTA_CONTACT]]                 — render contact-page link card
    //   [[CTA_PRODUCTS:handle1,handle2]] — render product result cards for the listed handles
    // Default points to the Shopify App Proxy path. Override via window.GT_CHAT_ENDPOINT.
    const ENDPOINT = (typeof window.GT_CHAT_ENDPOINT === 'string')
      ? window.GT_CHAT_ENDPOINT
      : '/apps/ai-chat';

    let history = [];
    let productIndex = null;
    let productIndexPromise = null;
    let offeredNewsletter = false;
    let offeredContact = false;

    // Keep the chat launcher reachable when the first-visit cookie banner is
    // visible on small screens. The banner is rendered by a snippet after this
    // section, so observe it instead of coupling to that snippet's lifecycle.
    function syncCookieConsentOffset() {
      const banner = document.querySelector('[data-cookie-consent]');
      const rootEl = document.documentElement;
      if (!banner) {
        rootEl.classList.remove('gt-cookie-consent-visible');
        rootEl.style.removeProperty('--gt-cookie-consent-offset');
        return;
      }
      const visible = !banner.hidden && banner.classList.contains('is-visible');
      if (!visible) {
        rootEl.classList.remove('gt-cookie-consent-visible');
        rootEl.style.removeProperty('--gt-cookie-consent-offset');
        return;
      }
      const card = banner.querySelector('.cookie-consent__card') || banner;
      const rect = card.getBoundingClientRect();
      rootEl.classList.add('gt-cookie-consent-visible');
      rootEl.style.setProperty('--gt-cookie-consent-offset', Math.ceil(rect.height + 20) + 'px');
    }

    // ---------- Keyword lists (comma-separated per locale) ----------
    function tokens(s) {
      return String(s == null ? '' : s)
        .split(',').map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
    }
    const KW = {
      discount:     tokens(I18N.kw && I18N.kw.discount),
      collab:       tokens(I18N.kw && I18N.kw.collab),
      storeHours:   tokens(I18N.kw && I18N.kw.storeHours),
      storeContact: tokens(I18N.kw && I18N.kw.storeContact),
      product:      tokens(I18N.kw && I18N.kw.product)
    };
    function has(text, list) {
      if (!list.length) return false;
      const t = text.toLowerCase();
      for (let i = 0; i < list.length; i++) if (t.indexOf(list[i]) !== -1) return true;
      return false;
    }

    // ---------- Intent ----------
    function detectIntent(text) {
      // Priority: collab > discount > store contact/hours > product.
      if (has(text, KW.collab))       return 'collab';
      if (has(text, KW.discount))     return 'discount';
      if (has(text, KW.storeContact)) return 'store_contact';
      if (has(text, KW.storeHours))   return 'store_hours';
      if (has(text, KW.product))      return 'product';
      // Fallback — OEM-code-ish tokens (optional letter prefix + 4+ digits).
      if (/[a-z]?\d{4,}/i.test(text)) return 'product';
      return 'general';
    }

    // ---------- Product index (shared products-data.json) ----------
    function normalize(s) {
      return String(s == null ? '' : s).toLowerCase().replace(/[\s\-._/|,]+/g, '');
    }
    function firstOem(s) {
      const r = String(s || '').split(/[|,]/)[0].trim();
      const t = r.split(/\s+/).filter(Boolean);
      return (t.length >= 2 && !(t[0].length <= 4 && t[1].length <= 4)) ? t[0] : r;
    }
    // Accent-folded normalizers for deterministic OEM / ref / title matching
    // (Turkish: ı→i, strip diacritics). gtNorm collapses to one comparable blob
    // (spaces/dashes/dots removed); gtWords yields accent-folded word tokens.
    function gtNorm(s) {
      return String(s == null ? '' : s).toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/ı/g, 'i')
        .replace(/[\s\-._/|,]+/g, '');
    }
    function gtWords(s) {
      return String(s == null ? '' : s).toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/ı/g, 'i')
        .split(/[^a-z0-9]+/).filter(function (w) { return w.length >= 2; });
    }
    // Conversational filler to ignore when title-matching (already accent-folded).
    var GT_STOPWORDS = new Set(['var','mi','yok','fiyat','fiyati','fiyatlari','nedir','kac','tl','lira','stok','stokta','mevcut','bu','su','parca','parcasi','urun','urunu','urunler','icin','ariyorum','lazim','acaba','musunuz','misiniz','satiyor','satiyormusunuz','sizde','siz','ile','ve','bir','kadar','ne','model','marka','arac']);
    function buildIndexFromData(data) {
      const out = [];
      if (!data || typeof data !== 'object') {
        productIndex = out;
        return productIndex;
      }
      const seen = new Set();
      for (const vt in data) {
        for (const br in data[vt]) {
          for (const par in data[vt][br]) {
            for (const sub in data[vt][br][par]) {
              const list = data[vt][br][par][sub] || [];
              for (let i = 0; i < list.length; i++) {
                const p = list[i];
                if (!p || !p.handle || seen.has(p.handle)) continue;
                seen.add(p.handle);
                // All OEM codes (the field can hold "A | B | C"), normalized,
                // length>=5 to avoid noise. Ref forms: "GT-Y1002"→"gty1002" plus
                // the bare "y1002" so a shopper can type it either way.
                const oemCodes = String(p.oem || '').split(/[|,/]/).map(gtNorm).filter(function (c) { return c.length >= 5; });
                const refRaw = gtNorm(p.ref);
                const refNorms = [refRaw, refRaw.replace(/^gt/, '')].filter(function (c) { return c.length >= 3; });
                out.push({
                  handle: p.handle,
                  title: p.title,
                  image: p.image,
                  vendor: br,
                  oem: firstOem(p.oem || p.ref || ''),
                  hay: normalize([p.title, p.oem, p.ref, p.handle, br].join(' ')),
                  oemCodes: oemCodes,
                  refNorms: refNorms,
                  titleNorm: gtNorm(p.title),
                  titleWords: gtWords(p.title)
                });
              }
            }
          }
        }
      }
      productIndex = out;
      return productIndex;
    }
    function readInlineProductsData() {
      const el = document.querySelector('[data-gt-products-data]');
      if (!el) return null;
      const text = (el.textContent || '').trim();
      if (!text || text === '{}') return null;
      try { return JSON.parse(text); } catch (_err) { return null; }
    }
    function buildIndex() {
      if (productIndex && productIndex.length) return productIndex;
      if (window.GT_PRODUCTS_DATA) return buildIndexFromData(window.GT_PRODUCTS_DATA);
      const inlineData = readInlineProductsData();
      if (inlineData) return buildIndexFromData(inlineData);
      return productIndex || [];
    }
    function ensureProductIndex() {
      const current = buildIndex();
      if (current.length) return Promise.resolve(current);
      if (productIndexPromise) return productIndexPromise;

      if (window.GT_PRODUCTS_DATA_PROMISE) {
        productIndexPromise = window.GT_PRODUCTS_DATA_PROMISE
          .then(function (data) {
            if (data) window.GT_PRODUCTS_DATA = data;
            return buildIndexFromData(data);
          })
          .catch(function () { return buildIndex(); });
        return productIndexPromise;
      }

      const meta = document.querySelector('meta[name="gt-products-url"]');
      const url = (typeof window.GT_CHAT_PRODUCTS_URL === 'string' && window.GT_CHAT_PRODUCTS_URL)
        ? window.GT_CHAT_PRODUCTS_URL
        : (meta && meta.getAttribute('content'));
      if (!url) return Promise.resolve(current);

      const dataPromise = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data) window.GT_PRODUCTS_DATA = data;
          return data;
        })
        .catch(function () { return null; });
      window.GT_PRODUCTS_DATA_PROMISE = dataPromise;
      productIndexPromise = dataPromise.then(function (data) { return data ? buildIndexFromData(data) : buildIndex(); });
      return productIndexPromise;
    }
    async function searchProducts(q, limit) {
      const n = normalize(q);
      if (n.length < 2) return [];
      const out = [];
      const idx = await ensureProductIndex();
      for (let i = 0; i < idx.length; i++) {
        if (idx[i].hay.indexOf(n) !== -1) {
          out.push(idx[i]);
          if (out.length >= (limit || 4)) break;
        }
      }
      return out;
    }

    // Deterministic OEM / ref / title matcher over the static products-data.json.
    // The LLM backend is unreliable with exact part numbers (it wrongly says
    // "not found" for codes we carry); this is exact, instant, and offline.
    // Returns ranked product entries with .score (OEM 100, ref 90, title 40+)
    // and .why, ready to hand straight to renderProducts.
    async function findLocalMatches(query, limit) {
      const idx = await ensureProductIndex();
      const qnorm = gtNorm(query);
      if (qnorm.length < 3) return [];
      const qWords = gtWords(query).filter(function (w) { return w.length >= 3 && !GT_STOPWORDS.has(w); });
      const scored = [];
      for (let i = 0; i < idx.length; i++) {
        const p = idx[i];
        let score = 0, why = '';
        if (p.oemCodes && p.oemCodes.some(function (c) { return qnorm.indexOf(c) !== -1; })) { score = 100; why = 'oem'; }
        else if (p.refNorms && p.refNorms.some(function (c) { return qnorm.indexOf(c) !== -1; })) { score = 90; why = 'ref'; }
        else if (p.titleNorm && qWords.length) {
          let hits = 0;
          for (let w = 0; w < qWords.length; w++) if (p.titleNorm.indexOf(qWords[w]) !== -1) hits++;
          if (hits >= 2) { score = 40 + hits; why = 'title'; }
        }
        if (score > 0) scored.push({ p: p, score: score, why: why });
      }
      scored.sort(function (a, b) { return b.score - a.score; });
      return scored.slice(0, limit || 5).map(function (s) {
        return {
          handle: s.p.handle, title: s.p.title, image: s.p.image,
          vendor: s.p.vendor, oem: s.p.oem, score: s.score, why: s.why
        };
      });
    }

    // ---------- Persistence ----------
    function persist() {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          state: root.dataset.state,
          history: history,
          offeredNewsletter: offeredNewsletter,
          offeredContact: offeredContact
        }));
      } catch (_err) {}
    }
    function restore() {
      try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        const data = JSON.parse(raw);
        if (!data || !Array.isArray(data.history)) return false;
        history = data.history;
        offeredNewsletter = !!data.offeredNewsletter;
        offeredContact = !!data.offeredContact;
        msgsEl.innerHTML = '';
        for (let i = 0; i < history.length; i++) {
          const m = history[i];
          if (m.role === 'user') renderUser(m.content);
          else renderStoredBot(m);
        }
        if (data.state === 'expanded' || data.state === 'minimized') {
          setState(data.state, true);
        }
        return true;
      } catch (_err) { return false; }
    }
    function renderStoredBot(m) {
      if (m.text) renderBot(m.text);
      if (m.products && m.products.length) {
        ensureProductIndex().then(function (idx) {
          const matches = m.products
            .map(function (h) { return idx.find(function (p) { return p.handle === h; }); })
            .filter(Boolean);
          if (matches.length) renderProducts(matches);
        }).catch(function () {});
      }
      if (m.cta === 'newsletter') renderNewsletterCta();
      if (m.cta === 'contact')    renderContactCta();
    }

    function setState(state, skipPersist) {
      root.dataset.state = state;
      if (state === 'expanded') setTimeout(function () { inputEl.focus(); }, 60);
      if (!skipPersist) persist();
    }

    // ---------- Rendering ----------
    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;').replace(/'/g,'&#039;');
    }
    function scrollToBottom() { msgsEl.scrollTop = msgsEl.scrollHeight; }

    // Pull product handles out of [label](/products/handle) and bare
    // /products/handle links the backend embeds in prose, returning the
    // cleaned text (links removed so they don't show as raw markdown), the
    // ordered unique handles, and a handle→label map for fallback cards.
    function gtExtractProducts(raw) {
      var handles = [];
      var labels = {};
      function norm(h) { return String(h || '').trim().replace(/[#?].*$/, '').replace(/\/+$/, ''); }
      function push(h, label) {
        h = norm(h);
        if (!h) return;
        if (handles.indexOf(h) === -1) handles.push(h);
        if (label && !labels[h]) labels[h] = String(label).trim();
      }
      var text = String(raw == null ? '' : raw);
      text = text.replace(
        /\[([^\]]*)\]\((?:https?:\/\/[^)\s]+?)?\/products\/([a-z0-9][a-z0-9._-]*)[^)]*\)/gi,
        function (_m, label, h) { push(h, label); return ''; }
      );
      text = text.replace(
        /(?:https?:\/\/[^\s)]+?)?\/products\/([a-z0-9][a-z0-9._-]*)/gi,
        function (_m, h) { push(h); return ''; }
      );
      text = text
        .split('\n')
        .filter(function (l) { return !/^\s*[-*•]\s*$/.test(l); })
        .join('\n')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .replace(/[ \t]{2,}/g, ' ')
        .trim();
      return { text: text, handles: handles, labels: labels };
    }

    // Minimal, XSS-safe inline markdown: escape EVERYTHING first, then re-add a
    // strict whitelist. External http(s) links only (no javascript: URIs).
    function gtInline(s) {
      s = esc(s);
      s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
        '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
      s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
      s = s.replace(/`([^`]+)`/g, '<code>$1</code>');
      return s;
    }

    // Block-level markdown → safe HTML (paragraphs, bullet/numbered lists).
    function gtMarkdown(raw) {
      var src = String(raw == null ? '' : raw).replace(/\r\n?/g, '\n');
      var blocks = src.split(/\n{2,}/);
      var out = [];
      for (var b = 0; b < blocks.length; b++) {
        var block = blocks[b];
        if (!block.trim()) continue;
        var lines = block.split('\n');
        var nonEmpty = lines.filter(function (l) { return l.trim(); });
        var listLines = lines.filter(function (l) { return /^\s*(?:[-*•]|\d+[.)])\s+/.test(l); });
        if (listLines.length && listLines.length === nonEmpty.length) {
          var ordered = /^\s*\d+[.)]\s+/.test(nonEmpty[0] || '');
          var items = lines.map(function (l) {
            var m = l.match(/^\s*(?:[-*•]|\d+[.)])\s+(.*)$/);
            return m ? '<li>' + gtInline(m[1]) + '</li>' : '';
          }).join('');
          out.push((ordered ? '<ol>' : '<ul>') + items + (ordered ? '</ol>' : '</ul>'));
        } else {
          out.push('<p>' + gtInline(block).replace(/\n/g, '<br>') + '</p>');
        }
      }
      return out.join('');
    }

    // Secure stock badge: reads Shopify's PUBLIC /products/<handle>.js (no auth,
    // no admin, no API key) and shows in-stock / out-of-stock on a card. Fails
    // silently — a missing badge is fine, a console error is not.
    function gtHydrateStock(span, handle) {
      if (!span || !handle) return;
      fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var qty = null;
          if (p.variants && p.variants.length === 1
              && typeof p.variants[0].inventory_quantity === 'number'
              && p.variants[0].inventory_management) {
            qty = p.variants[0].inventory_quantity;
          }
          if (p.available) {
            span.className = 'gt-product__stock gt-product__stock--in';
            if (qty != null && qty > 0 && I18N.stockCount) {
              span.textContent = String(I18N.stockCount).replace('{{ count }}', qty).replace('{{count}}', qty);
            } else {
              span.textContent = I18N.stockIn || '';
            }
          } else {
            span.className = 'gt-product__stock gt-product__stock--out';
            span.textContent = I18N.stockOut || '';
          }
        })
        .catch(function () {});
    }

    function renderUser(text) {
      const div = document.createElement('div');
      div.className = 'gt-msg gt-msg--user';
      div.textContent = text;
      msgsEl.appendChild(div);
      scrollToBottom();
    }
    function renderBot(text) {
      const div = document.createElement('div');
      div.className = 'gt-msg gt-msg--bot gt-msg--rich';
      const html = gtMarkdown(text);
      if (html) div.innerHTML = html;
      else div.textContent = String(text == null ? '' : text);
      msgsEl.appendChild(div);
      scrollToBottom();
    }
    function renderTyping() {
      const div = document.createElement('div');
      div.className = 'gt-msg gt-msg--bot gt-msg--typing';
      div.innerHTML = '<span></span><span></span><span></span>';
      msgsEl.appendChild(div);
      scrollToBottom();
      return div;
    }
    function renderProducts(list) {
      const wrap = document.createElement('div');
      wrap.className = 'gt-products';
      for (let i = 0; i < list.length; i++) {
        const p = list[i];
        const a = document.createElement('a');
        a.className = 'gt-product';
        a.href = '/products/' + p.handle;
        const img = p.image ? (p.image + (p.image.indexOf('?') === -1 ? '?width=120' : '&width=120')) : '';
        const imgTag = img
          ? '<img class="gt-product__img" src="' + esc(img) + '" alt="' + esc(p.title || '') + '" loading="lazy">'
          : '<div class="gt-product__img"></div>';
        // vendor·OEM when known; otherwise a plain "view product" hint so a
        // fallback card (handle not in the local index) never looks empty.
        let meta;
        if (p.oem) meta = '<strong>' + esc(p.vendor || '') + '</strong> · OEM ' + esc(p.oem);
        else if (p.vendor) meta = '<strong>' + esc(p.vendor) + '</strong>';
        else meta = esc(I18N.productView || '');
        a.innerHTML = imgTag
          + '<div class="gt-product__info">'
          +   '<div class="gt-product__title">' + esc(p.title) + '</div>'
          +   '<div class="gt-product__meta">' + meta + '</div>'
          +   '<span class="gt-product__stock" data-stock hidden></span>'
          + '</div>';
        const stockEl = a.querySelector('[data-stock]');
        if (stockEl) { stockEl.removeAttribute('hidden'); gtHydrateStock(stockEl, p.handle); }
        wrap.appendChild(a);
      }
      msgsEl.appendChild(wrap);
      scrollToBottom();
    }
    function renderContactCta() {
      const wrap = document.createElement('div');
      wrap.className = 'gt-cta';
      const a = document.createElement('a');
      a.href = '/pages/contact';
      a.className = 'gt-cta__btn';
      a.innerHTML = ''
        + '<span class="gt-cta__btn-icon" aria-hidden="true">'
        +   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>'
        + '</span>'
        + '<span class="gt-cta__btn-label">'
        +   '<span class="gt-cta__btn-title"></span>'
        +   '<span class="gt-cta__btn-sub"></span>'
        + '</span>'
        + '<span class="gt-cta__btn-arrow" aria-hidden="true">'
        +   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'
        + '</span>';
      a.querySelector('.gt-cta__btn-title').textContent = I18N.ctaContactTitle;
      a.querySelector('.gt-cta__btn-sub').textContent = I18N.ctaContactSub;
      wrap.appendChild(a);
      msgsEl.appendChild(wrap);
      scrollToBottom();
      offeredContact = true;
    }
    function renderNewsletterCta() {
      const wrap = document.createElement('div');
      wrap.className = 'gt-cta';
      wrap.innerHTML = ''
        + '<form class="gt-cta__form" novalidate>'
        +   '<input type="email" required autocomplete="email">'
        +   '<button type="submit"></button>'
        + '</form>'
        + '<div class="gt-cta__status" hidden></div>';
      const form   = wrap.querySelector('form');
      const input  = wrap.querySelector('input');
      const btn    = wrap.querySelector('button');
      const status = wrap.querySelector('.gt-cta__status');
      input.placeholder = I18N.nlPlaceholder;
      btn.textContent = I18N.nlSubmit;

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const email = input.value.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          status.hidden = false;
          status.className = 'gt-cta__status gt-cta__status--err';
          status.textContent = I18N.nlInvalid;
          return;
        }
        btn.disabled = true;
        btn.textContent = '...';
        try {
          const fd = new FormData();
          fd.append('form_type', 'customer');
          fd.append('utf8', '✓');
          fd.append('contact[email]', email);
          fd.append('contact[tags]', 'newsletter');
          fd.append('contact[accepts_marketing]', '1');
          const res = await fetch('/contact', { method: 'POST', body: fd });
          if (!res.ok && res.status !== 0 && res.status !== 302) throw new Error('bad status');
          form.remove();
          status.hidden = false;
          status.className = 'gt-cta__status gt-cta__status--ok';
          status.textContent = I18N.nlSuccess;
        } catch (_err) {
          btn.disabled = false;
          btn.textContent = I18N.nlSubmit;
          status.hidden = false;
          status.className = 'gt-cta__status gt-cta__status--err';
          status.textContent = I18N.nlError;
        }
      });

      msgsEl.appendChild(wrap);
      scrollToBottom();
      offeredNewsletter = true;
    }

    // ---------- Router ----------
    function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    // POST the conversation to the backend with a hard timeout. Render's free
    // tier cold-starts (first request after idle can take ~30-50s), so allow
    // generous time before giving up rather than failing fast.
    //
    // CRITICAL: map each turn to the backend's {role, content} contract. The
    // widget stores USER turns as {role,content} but ASSISTANT turns as
    // {role,text}; reading only `.text` (the old bug) sent EMPTY content for
    // every user message, so the backend never saw the question and always
    // replied with a generic greeting. Read whichever field the turn has.
    function postBackend(hist, timeoutMs) {
      const ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      const to = ctrl ? setTimeout(function () { ctrl.abort(); }, timeoutMs) : null;
      return fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          messages: hist.map(function (m) {
            return { role: m.role, content: String(m.content != null ? m.content : (m.text || '')) };
          })
        }),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (res) {
        if (to) clearTimeout(to);
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      }, function (err) {
        if (to) clearTimeout(to);
        throw err;
      });
    }

    async function handleUserMessage(text) {
      history.push({ role: 'user', content: text });
      renderUser(text);
      persist();

      // Deterministic local match FIRST (OEM / ref / GT-code / title) against
      // the static products-data.json. LLMs mishandle exact part numbers, so
      // when the shopper types a code we KNOW we carry, answer it ourselves
      // rather than risk the backend wrongly replying "not found".
      let local = [];
      try { local = await findLocalMatches(text, 6); } catch (_e) { local = []; }
      const strongCode = local.filter(function (m) { return m.score >= 90; });
      if (strongCode.length) {
        const t0 = renderTyping();
        await sleep(220);
        t0.remove();
        const cards = strongCode.slice(0, 5);
        const head = String(I18N.replyFoundTpl || '')
          .replace('{{ count }}', cards.length).replace('{{count}}', cards.length);
        if (head) renderBot(head);
        renderProducts(cards);
        history.push({ role: 'assistant', text: head, products: cards.map(function (p) { return p.handle; }) });
        persist();
        return;
      }

      const typing = renderTyping();
      // Cold-start hint: if the backend is still spinning up after a few
      // seconds, reassure the user instead of letting it look frozen.
      let warmTimer = setTimeout(function () {
        if (typing.isConnected && I18N.warming) {
          const note = document.createElement('div');
          note.className = 'gt-chat__hint';
          note.setAttribute('data-gt-hint', '1');
          note.textContent = I18N.warming;
          msgsEl.appendChild(note);
          scrollToBottom();
        }
      }, 6000);
      function clearWarm() {
        clearTimeout(warmTimer);
        const h = msgsEl.querySelector('[data-gt-hint]');
        if (h) h.remove();
      }

      // Backend-first: the server-side LLM is the brain. It returns text with
      // optional CTA markers that we parse and render. If it's unreachable
      // (no endpoint, timeout, network error, non-OK status) we fall back to
      // client-side keyword routing so the widget stays useful offline.
      if (ENDPOINT) {
        try {
          const data = await postBackend(history, 45000);
          const reply = (data && data.reply != null) ? String(data.reply) : '';
          clearWarm();
          typing.remove();
          await renderBackendReply(reply, local);
          persist();
          return;
        } catch (err) {
          // No raw debug text in the conversation (customers shouldn't see
          // stack traces). Log the real reason for us, drop the typing dots,
          // and still try to help from the local index so a product/stock
          // question gets a useful answer even while the backend is down.
          const reason = (err && (err.message || String(err))) || 'unknown';
          console.warn('[gt-chat] backend unavailable:', reason, '· endpoint:', ENDPOINT);
          clearWarm();
          typing.remove();
          await handleLocally(text);
          persist();
          return;
        }
      }

      clearWarm();
      typing.remove();
      await handleLocally(text);
      persist();
    }

    // Parse a backend reply: extract CTA markers, render the cleaned text,
    // then fire the requested CTAs / product cards. `localMatches` are the
    // deterministic products-data.json hits for this turn — merged in as a
    // safety net so a product we carry is shown even if the LLM omitted it.
    async function renderBackendReply(raw, localMatches) {
      let text = String(raw || '');

      const wantNewsletter = text.indexOf('[[CTA_NEWSLETTER]]') !== -1;
      const wantContact    = text.indexOf('[[CTA_CONTACT]]')    !== -1;

      // [[CTA_PRODUCTS:handle-a,handle-b,handle-c]]
      const productRe = /\[\[CTA_PRODUCTS:([^\]]+)\]\]/;
      const prodMatch = text.match(productRe);
      const handles = prodMatch
        ? prodMatch[1].split(',').map(function (s) { return s.trim(); }).filter(Boolean)
        : [];

      text = text
        .replace(/\[\[CTA_NEWSLETTER\]\]/g, '')
        .replace(/\[\[CTA_CONTACT\]\]/g, '')
        .replace(productRe, '')
        .trim();

      // The backend ALSO embeds the same products as markdown links in the
      // prose (e.g. "- [STRALIS Fan Blade](/products/...)"). Extract those,
      // strip them from the text (so they don't render as raw brackets), and
      // merge with the CTA handles — CTA order first, prose-only extras after.
      const extracted = gtExtractProducts(text);
      text = extracted.text;
      for (let k = 0; k < extracted.handles.length; k++) {
        if (handles.indexOf(extracted.handles[k]) === -1) handles.push(extracted.handles[k]);
      }

      if (text) renderBot(text);

      let matches = [];
      if (handles.length) {
        const idx = await ensureProductIndex();
        matches = handles.map(function (h) {
          const found = idx.find(function (p) { return p.handle === h; });
          if (found) return found;
          // Recommendation whose handle isn't in the local index yet — still
          // show a clickable card (label from the markdown) rather than drop it.
          return { handle: h, title: extracted.labels[h] || h.replace(/-/g, ' '), image: '', vendor: '', oem: '' };
        });
      }
      // Safety net: append deterministic local matches the backend didn't
      // surface (deduped, capped) so we never fail to show a part we carry.
      if (localMatches && localMatches.length) {
        for (let li = 0; li < localMatches.length && matches.length < 5; li++) {
          const lm = localMatches[li];
          if (matches.some(function (p) { return p.handle === lm.handle; })) continue;
          matches.push(lm);
        }
      }
      if (matches.length) renderProducts(matches);

      // CTAs: show at most once per conversation.
      let storedCta = null;
      if (wantNewsletter && !offeredNewsletter) { renderNewsletterCta(); storedCta = 'newsletter'; }
      else if (wantContact && !offeredContact)  { renderContactCta();    storedCta = 'contact'; }

      // Empty reply guard — if backend returned nothing usable, at least say something.
      if (!text && !matches.length && !storedCta) {
        renderBot(I18N.noReply);
        history.push({ role: 'assistant', text: I18N.noReply });
        return;
      }

      history.push({
        role: 'assistant',
        text: text,
        products: matches.map(function (p) { return p.handle; }),
        cta: storedCta
      });
    }

    // Offline-safe router: keyword-driven intents. Used when the backend
    // is unreachable or not configured.
    async function handleLocally(text) {
      const intent = detectIntent(text);

      if (intent === 'discount') {
        renderBot(I18N.replyDiscount);
        const cta = offeredNewsletter ? null : 'newsletter';
        if (!offeredNewsletter) renderNewsletterCta();
        history.push({ role: 'assistant', text: I18N.replyDiscount, cta: cta });
      } else if (intent === 'collab') {
        renderBot(I18N.replyCollab);
        const cta = offeredContact ? null : 'contact';
        if (!offeredContact) renderContactCta();
        history.push({ role: 'assistant', text: I18N.replyCollab, cta: cta });
      } else if (intent === 'store_hours') {
        renderBot(I18N.replyStoreHours);
        history.push({ role: 'assistant', text: I18N.replyStoreHours });
      } else if (intent === 'store_contact') {
        renderBot(I18N.replyStoreContact);
        history.push({ role: 'assistant', text: I18N.replyStoreContact });
      } else if (intent === 'product') {
        const matches = await searchProducts(text, 4);
        if (matches.length) {
          const countTokenSpaced = '{' + '{ count }' + '}';
          const countTokenCompact = '{' + '{count}' + '}';
          const head = String(I18N.replyFoundTpl || '')
            .replace(countTokenSpaced, matches.length)
            .replace(countTokenCompact, matches.length);
          renderBot(head);
          renderProducts(matches);
          history.push({
            role: 'assistant',
            text: head,
            products: matches.map(function (p) { return p.handle; })
          });
        } else {
          renderBot(I18N.replyProductNone);
          history.push({ role: 'assistant', text: I18N.replyProductNone });
        }
      } else if (/(merhaba|selam|g[üu]nayd|iyi g[üu]n|iyi ak[sş]am|nas[ıi]ls[ıi]n|nasilsin|te[sş]ekk[üu]r|sa[ğg]ol|sa[ğg] ol|eyvallah|hello|thanks|thank you|hey there|hi there)/i.test(text)) {
        // Friendly offline small talk so a greeting doesn't get the canned
        // "I can only answer product questions" line when the backend is down.
        renderBot(I18N.replyGreeting || I18N.intro);
        history.push({ role: 'assistant', text: I18N.replyGreeting || I18N.intro });
      } else {
        renderBot(I18N.backendDown);
        history.push({ role: 'assistant', text: I18N.backendDown });
      }
    }

    // ---------- Public open-from-landing API ----------
    function ensureIntro() {
      if (history.length) return;
      renderBot(I18N.intro);
      history.push({ role: 'assistant', text: I18N.intro });
    }
    function openWithQuery(query) {
      const q = (query || '').trim();
      if (root.dataset.state === 'closed') {
        history = [];
        offeredNewsletter = false;
        offeredContact = false;
        msgsEl.innerHTML = '';
        ensureIntro();
      }
      setState('expanded');
      if (q) handleUserMessage(q);
    }

    function wireAiSearch() {
      const form = document.querySelector('.ai-search__form');
      if (form && !form.dataset.gtWired) {
        form.dataset.gtWired = '1';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          const input = form.querySelector('.ai-search__input');
          const q = input ? input.value : '';
          if (input) input.value = '';
          openWithQuery(q);
        });
      }
      // Preset prompt chips — fill the main AI search input, don't auto-send.
      document.querySelectorAll('.ai-prompt').forEach(function (a) {
        if (a.dataset.gtWired) return;
        a.dataset.gtWired = '1';
        a.addEventListener('click', function (e) {
          e.preventDefault();
          const searchInput = document.querySelector('.ai-search__input');
          if (!searchInput) return;
          const textSpan = a.querySelector('span:not(.ai-prompt__var)') || a;
          const text = (textSpan.textContent || '').replace(/\s+/g, ' ').trim();
          searchInput.value = text;
          searchInput.focus();
          const idx = text.indexOf('[X]');
          if (idx >= 0) searchInput.setSelectionRange(idx, idx + 3);
          else searchInput.setSelectionRange(text.length, text.length);
        });
      });
    }
    wireAiSearch();
    new MutationObserver(wireAiSearch).observe(document.body, { childList: true, subtree: true });
    syncCookieConsentOffset();
    window.addEventListener('resize', syncCookieConsentOffset);
    new MutationObserver(syncCookieConsentOffset).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });

    // ---------- Event wiring ----------
    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      const q = inputEl.value.trim();
      if (!q) return;
      inputEl.value = '';
      ensureIntro();
      handleUserMessage(q);
    });

    fabEl.addEventListener('click', function () {
      if (root.dataset.state === 'closed') {
        history = [];
        offeredNewsletter = false;
        offeredContact = false;
        msgsEl.innerHTML = '';
      }
      ensureIntro();
      setState('expanded');
    });
    minBtn.addEventListener('click', function () { setState('minimized'); });
    closeBtn.addEventListener('click', function () {
      history = [];
      offeredNewsletter = false;
      offeredContact = false;
      msgsEl.innerHTML = '';
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (_err) {}
      setState('closed');
    });

    restore();

    window.GT_CHAT = { open: openWithQuery };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-rehber"]) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-rehber-more]');
    var grid = document.querySelector('[data-rehber-grid]');
    if (!btn || !grid) return;
    var step = parseInt(btn.getAttribute('data-step'), 10) || 9;
    btn.addEventListener('click', function () {
      var hidden = grid.querySelectorAll('.rcard--hidden');
      for (var i = 0; i < step && i < hidden.length; i++) {
        hidden[i].classList.remove('rcard--hidden');
      }
      if (grid.querySelectorAll('.rcard--hidden').length === 0) {
        btn.parentNode.style.display = 'none';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Every "Alışverişe devam et" / "Continue shopping" link on the cart page
  // should send the user back to the page they were on before opening the
  // cart, not to a generic /collections/all or /. Hijack the click → go
  // history.back() when the referrer is same-origin (= the user really did
  // arrive from inside this site), and fall back to / when they jumped
  // straight to the cart (deep link, refresh, bookmark, etc).
  (function () {
    function goBack(e) {
      e.preventDefault();
      var sameOrigin = false;
      try {
        sameOrigin = document.referrer && new URL(document.referrer).origin === window.location.origin;
      } catch (_e) {}
      if (sameOrigin && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    }
    document.querySelectorAll('[data-continue-shopping]').forEach(function (el) {
      el.addEventListener('click', goBack);
    });
  })();

  (function () {
    const form = document.querySelector('[data-cart-form]');
    if (!form) return;
    const I18N = window.GT_CART_I18N || {};
    const CURRENCY = I18N.currency || 'TRY';

    let fmt;
    try {
      fmt = new Intl.NumberFormat(CURRENCY === 'USD' ? 'en-US' : 'tr-TR', { style: 'currency', currency: CURRENCY });
    } catch (_e) {
      // Fallback when the server-emitted currency code is unusable for any
      // reason — never let a formatter throw stop the whole widget.
      fmt = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' });
    }
    function money(cents) { return fmt.format(cents / 100); }

    // Currency-aware price write. Keeps data-gt-amt + data-gt-orig fresh and
    // asks the USD display converter (window.GTCur) to re-render, so prices
    // that change on qty updates stay correct in $ mode. In ₺ mode it's just
    // a normal textContent write. Checkout is always ₺ regardless.
    function setMoney(el, cents) {
      if (!el) return;
      var tl = money(cents);
      el.setAttribute('data-gt-amt', cents);
      el.setAttribute('data-gt-orig', tl);
      el.removeAttribute('data-gt-on');
      el.textContent = tl;
      if (window.GTCur && window.GTCur.apply) window.GTCur.apply();
    }

    // Per-line state: pending debounce timer. Rapid +/- clicks coalesce into
    // one network call (280ms debounce); the actual write is then handed to the
    // shared serialized cart queue (window.GTCart) so it can never race the
    // global card steppers or the checkout attribute write. UI stays interactive.
    const pending  = new Map(); // key → timer id
    const DEBOUNCE_MS = 280;

    function itemByKey(key) {
      return form.querySelector('.cart-item[data-key="' + CSS.escape(key) + '"]');
    }

    // Optimistic price update — recomputes the line price from the per-item
    // unit price stored in data-unit-price, so the user sees their change
    // instantly without waiting for the server round-trip.
    function paintLinePrice(itemEl, qty) {
      if (!itemEl) return;
      const unit = Number(itemEl.dataset.unitPrice || 0);
      if (!unit) return;
      const priceEl = itemEl.querySelector('[data-line-price] .cart-item__price-now');
      setMoney(priceEl, unit * qty);
    }

    function scheduleUpdate(key, qty) {
      clearTimeout(pending.get(key));
      pending.set(key, setTimeout(function () {
        pending.delete(key);
        commitUpdate(key, qty);
      }, DEBOUNCE_MS));
    }

    async function commitUpdate(key, qty) {
      const itemEl = itemByKey(key);
      // Fade only on removal — qty changes must remain clickable.
      if (qty === 0 && itemEl) itemEl.classList.add('is-removing');

      // Serialize through the shared cart queue so this write can't race the
      // global card steppers or the checkout attribute write. ≤8s abort keeps
      // the queue from getting stuck behind a hung request.
      const op = function () {
        const ctrl = new AbortController();
        const to = setTimeout(function () { ctrl.abort(); }, 8000);
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: { [key]: qty } }),
          signal: ctrl.signal,
          keepalive: true // survive a navigation that starts mid-flight
        }).then(function (res) {
          clearTimeout(to);
          if (!res.ok) throw new Error('update failed ' + res.status);
          return res.json();
        }, function (err) { clearTimeout(to); throw err; });
      };

      try {
        const cart = await (window.GTCart && window.GTCart.enqueue ? window.GTCart.enqueue(op) : op());
        if (!cart) return;

        if (qty === 0 && itemEl) {
          itemEl.style.transition = 'opacity 0.2s, transform 0.2s';
          itemEl.style.opacity = '0';
          itemEl.style.transform = 'translateX(-6px)';
          setTimeout(function () { itemEl.remove(); }, 220);
        } else if (itemEl) {
          // Reconcile with server price (handles discounts Shopify adds server-side).
          const item = cart.items.find(function (i) { return i.key === key; });
          if (item) {
            const priceEl = itemEl.querySelector('[data-line-price] .cart-item__price-now');
            setMoney(priceEl, item.final_line_price);
            // Keep per-line unit price fresh in case promos shifted it.
            itemEl.dataset.unitPrice = String(item.final_price);
          }
        }

        // Totals
        const subtotalEl = form.querySelector('[data-subtotal]');
        const totalEl    = form.querySelector('[data-total]');
        setMoney(subtotalEl, cart.items_subtotal_price || cart.total_price);
        setMoney(totalEl, cart.total_price);

        // Header count + navbar badge
        const countEl = document.querySelector('[data-cart-count]');
        if (countEl && I18N.itemCountTemplate) {
          countEl.textContent = I18N.itemCountTemplate.replace('__n__', cart.item_count);
        }
        const navBadge = document.querySelector('.head-icons__cart sup');
        if (navBadge) {
          navBadge.textContent = cart.item_count;
          if (cart.item_count > 0) navBadge.removeAttribute('hidden');
          else navBadge.setAttribute('hidden', '');
        }

        if (cart.item_count === 0) window.location.reload();
      } catch (err) {
        console.error(err);
        if (itemEl) itemEl.classList.remove('is-removing');
      }
    }

    // +/- steppers — paint optimistically, debounce the network call.
    form.addEventListener('click', function (e) {
      const step = e.target.closest('[data-qty-step]');
      if (step) {
        const qtyWrap = step.closest('[data-qty]');
        const input = qtyWrap.querySelector('[data-qty-input]');
        const itemEl = step.closest('.cart-item');
        const delta = parseInt(step.dataset.qtyStep, 10);
        const newVal = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = newVal;
        if (newVal > 0) paintLinePrice(itemEl, newVal);
        scheduleUpdate(input.dataset.key, newVal);
        return;
      }
      const remove = e.target.closest('[data-remove-key]');
      if (remove) {
        clearTimeout(pending.get(remove.dataset.removeKey));
        commitUpdate(remove.dataset.removeKey, 0);
      }
    });

    // Typing directly into the qty input — same debounce.
    form.addEventListener('input', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      const input = e.target;
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      const itemEl = input.closest('.cart-item');
      if (qty > 0) paintLinePrice(itemEl, qty);
      scheduleUpdate(input.dataset.key, qty);
    });

    // The checkout gate (separate IIFE below) dispatches this right before it
    // navigates: commit any still-debounced qty change NOW so it lands in the
    // shared queue before checkout reads the cart.
    window.addEventListener('gt:cart-flush', function () {
      const keys = [];
      pending.forEach(function (timer, key) { clearTimeout(timer); keys.push(key); });
      pending.clear();
      keys.forEach(function (key) {
        const input = form.querySelector('[data-qty-input][data-key="' + CSS.escape(key) + '"]');
        if (input) commitUpdate(key, Math.max(0, parseInt(input.value, 10) || 0));
      });
    });

    // Last-resort persistence: if the page unloads/hides (continue shopping,
    // back button, URL bar, tab close) with a qty change still debounced, push
    // it with sendBeacon so the change is never lost.
    function beaconFlushCart() {
      if (!pending.size) return;
      const updates = {};
      pending.forEach(function (timer, key) {
        clearTimeout(timer);
        const input = form.querySelector('[data-qty-input][data-key="' + CSS.escape(key) + '"]');
        if (input) updates[key] = Math.max(0, parseInt(input.value, 10) || 0);
      });
      pending.clear();
      if (!Object.keys(updates).length) return;
      const body = JSON.stringify({ updates: updates });
      try {
        if (navigator.sendBeacon) {
          const blob = new Blob([body], { type: 'application/json' });
          if (navigator.sendBeacon('/cart/update.js', blob)) return;
        }
      } catch (_e) {}
      try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }); } catch (_e) {}
    }
    window.addEventListener('pagehide', beaconFlushCart);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') beaconFlushCart();
    });
  })();
  // ---- Fatura (e-invoice) capture + checkout gating ----
  // Buyer must pick a fatura type and fill its required fields before checkout.
  // On a valid checkout attempt we persist the data as cart attributes via
  // /cart/update.js (→ order note_attributes that BirFatura reads) and only then
  // navigate to /checkout. Wrapped in try/catch so any failure here can never
  // break the rest of the cart bundle.
  (function () {
    try {
      var root = document.querySelector('[data-fatura]');
      var form = document.querySelector('[data-cart-form]');
      if (!root || !form) return;

      var typeBtns = root.querySelectorAll('[data-fatura-type]');
      var panel = root.querySelector('[data-fatura-panel]');
      var sharedGroup = root.querySelector('[data-fatura-shared]');
      var alertEl = root.querySelector('[data-fatura-alert]');
      var alertText = root.querySelector('[data-fatura-alert-text]');
      var checkoutBtn = form.querySelector('[name="checkout"]');
      var STORE_KEY = 'gt_fatura_v1';
      var selected = '';
      var submitting = false;

      function allInputs() { return root.querySelectorAll('[data-fatura-input]'); }
      function activeScopes() { return selected ? [selected, 'shared'] : []; }

      function showAlert(msg) { if (alertText) alertText.textContent = msg; if (alertEl) alertEl.hidden = false; }
      function clearAlert() { if (alertEl) alertEl.hidden = true; }

      function setType(t) {
        if (t !== 'bireysel' && t !== 'kurumsal') return;
        selected = t;
        typeBtns.forEach(function (b) {
          var on = b.getAttribute('data-fatura-type') === t;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (panel) panel.hidden = false;
        if (sharedGroup) sharedGroup.hidden = false;
        root.querySelectorAll('[data-fatura-group]').forEach(function (g) {
          g.hidden = g.getAttribute('data-fatura-group') !== t;
        });
        clearAlert();
        persist();
      }

      // Official T.C. Kimlik No checksum (11 digits).
      function validTCKN(v) {
        if (!/^[1-9][0-9]{10}$/.test(v)) return false;
        var d = v.split('').map(Number);
        var odd = d[0] + d[2] + d[4] + d[6] + d[8];
        var even = d[1] + d[3] + d[5] + d[7];
        if ((((odd * 7 - even) % 10) + 10) % 10 !== d[9]) return false;
        var s = 0; for (var i = 0; i < 10; i++) s += d[i];
        return s % 10 === d[10];
      }
      function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

      function fieldError(inp) {
        var v = (inp.value || '').trim();
        if (inp.hasAttribute('data-req') && !v) return 'Bu alan zorunlu.';
        if (inp.hasAttribute('data-tckn') && v && !validTCKN(v)) return 'Geçerli bir T.C. Kimlik No giriniz.';
        if (inp.hasAttribute('data-vkn') && v && !/^[0-9]{10}$/.test(v)) return 'VKN 10 haneli olmalıdır.';
        if (inp.hasAttribute('data-email') && v && !validEmail(v)) return 'Geçerli bir e-posta giriniz.';
        return '';
      }

      function validate(mark) {
        clearAlert();
        if (!selected) { if (mark) showAlert('Lütfen fatura tipini seçiniz (Bireysel / Kurumsal).'); return false; }
        var scopes = activeScopes();
        var ok = true, firstBad = null;
        allInputs().forEach(function (inp) {
          var errEl = inp.parentNode.querySelector('[data-err]');
          if (scopes.indexOf(inp.getAttribute('data-scope')) === -1) {
            inp.classList.remove('is-invalid'); if (errEl) errEl.textContent = ''; return;
          }
          var err = fieldError(inp);
          if (err) {
            ok = false; if (!firstBad) firstBad = inp;
            if (mark) { inp.classList.add('is-invalid'); if (errEl) errEl.textContent = err; }
          } else { inp.classList.remove('is-invalid'); if (errEl) errEl.textContent = ''; }
        });
        if (!ok && mark) { showAlert('Lütfen fatura bilgilerinizi eksiksiz ve doğru giriniz.'); if (firstBad) firstBad.focus(); }
        return ok;
      }

      function attributesObj() {
        var attrs = {
          'Fatura Tipi': '', 'Ad Soyad': '', 'TCKN': '', 'Firma Ünvanı': '',
          'VKN': '', 'Vergi Dairesi': '', 'Fatura E-posta': '', 'Fatura Telefon': '', 'Fatura İl': '', 'Fatura İlçe': '', 'Fatura Adresi': ''
        };
        attrs['Fatura Tipi'] = selected === 'kurumsal' ? 'Kurumsal' : (selected === 'bireysel' ? 'Bireysel' : '');
        var scopes = activeScopes();
        allInputs().forEach(function (inp) {
          if (scopes.indexOf(inp.getAttribute('data-scope')) === -1) return;
          attrs[inp.getAttribute('data-key')] = (inp.value || '').trim();
        });
        return attrs;
      }

      function valuesMap() { var m = {}; allInputs().forEach(function (inp) { m[inp.getAttribute('data-key')] = inp.value; }); return m; }
      function persist() { try { localStorage.setItem(STORE_KEY, JSON.stringify({ t: selected, v: valuesMap() })); } catch (_e) {} }
      function restore() {
        try {
          var raw = localStorage.getItem(STORE_KEY); if (!raw) return;
          var s = JSON.parse(raw);
          if (s && s.v) allInputs().forEach(function (inp) { var k = inp.getAttribute('data-key'); if (s.v[k] != null) inp.value = s.v[k]; });
          if (s && (s.t === 'bireysel' || s.t === 'kurumsal')) setType(s.t);
        } catch (_e) {}
      }

      typeBtns.forEach(function (b) {
        b.addEventListener('click', function () { setType(b.getAttribute('data-fatura-type')); });
      });
      allInputs().forEach(function (inp) {
        inp.addEventListener('input', function () {
          persist();
          if (inp.classList.contains('is-invalid') && !fieldError(inp)) {
            inp.classList.remove('is-invalid');
            var errEl = inp.parentNode.querySelector('[data-err]'); if (errEl) errEl.textContent = '';
          }
        });
        // Enter inside a (non-textarea) fatura field must not trigger checkout.
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && inp.tagName !== 'TEXTAREA') e.preventDefault();
        });
      });

      // Gate the whole cart form: the only submit path is the checkout button
      // (qty controls are AJAX). Validate → save attributes → go to checkout.
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submitting) return;
        if (!validate(true)) { try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_e) {} return; }
        submitting = true;
        var orig = checkoutBtn ? checkoutBtn.innerHTML : '';
        if (checkoutBtn) { checkoutBtn.disabled = true; checkoutBtn.classList.add('is-loading'); }

        // 1) Force any still-debounced qty change to commit into the shared queue.
        try { window.dispatchEvent(new Event('gt:cart-flush')); } catch (_e) {}

        // 2) Wait for EVERY cart write (qty + remove + in-flight) to drain, THEN
        //    write the fatura attributes (also serialized), THEN go to checkout —
        //    so checkout never reads a half-applied / racing cart.
        var idle = (window.GTCart && window.GTCart.idle) ? window.GTCart.idle() : Promise.resolve();
        function saveAttrs() {
          var op = function () {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: attributesObj() })
            }).then(function (r) { return r.json(); });
          };
          return (window.GTCart && window.GTCart.enqueue) ? window.GTCart.enqueue(op) : op();
        }

        var finished = false;
        function go() { if (finished) return; finished = true; window.location.href = '/checkout'; }
        function fail() {
          if (finished) return; finished = true;
          submitting = false;
          if (checkoutBtn) { checkoutBtn.disabled = false; checkoutBtn.classList.remove('is-loading'); checkoutBtn.innerHTML = orig; }
          showAlert('Bir hata oluştu, lütfen tekrar deneyiniz.');
        }
        idle.then(saveAttrs).then(go, fail);
        // Safety: never trap the buyer if a request hangs.
        setTimeout(function () { if (!finished) go(); }, 5000);
      });

      // Returning from /checkout via the browser back button restores this page
      // from the bfcache with submitting=true and the button left disabled →
      // checkout becomes unclickable. Reset the gate every time the page is shown.
      window.addEventListener('pageshow', function () {
        submitting = false;
        if (checkoutBtn) { checkoutBtn.disabled = false; checkoutBtn.classList.remove('is-loading'); }
      });

      restore();
    } catch (_e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-browser"] && !Shopify.designMode) return;
  try {
    
  // Wrapped in IIFE + try/catch so top-level identifiers don't leak into the
  // shared bundle scope and any runtime error here can't propagate out and
  // silently kill unrelated section IIFEs (e.g. the navbar mega-menu handler
  // in header.liquid, which is in the same concatenated bundle).
  (function () {
  try {
  // Subcategory icon map: { sub_key: { url, color } }. Loaded from a JSON
  // script tag rendered server-side, because the surrounding asset bundling
  // tag does not evaluate Liquid filters like `asset_url`.
  const ICON = (function () {
    try {
      const node = document.querySelector('[data-gt-subcat-icons]');
      return node ? JSON.parse(node.textContent) : {};
    } catch (_e) { return {}; }
  })();

  // 11 systems matching `Kategori Resimleri/` — order, labels and subs all
  // come straight from the folder/PNG layout (ordinal prefix stripped).
  // Sub keys mirror the icon filenames in `assets/`. The TIPI_MAP in
  // `scripts/rebuild-products-data.mjs` routes Shopify products onto these
  // exact (meta, sub) pairs; keep both files in sync when adding new
  // subcategories.
  // Category taxonomy (vehicle types, brands, systems, subcategories, photos)
  // is parsed synchronously from the inline JSON in snippets/gt-taxonomy.liquid,
  // which the rebuild script regenerates from Shopify metaobjects. This is the
  // single source of truth: META, BROWSER_DATA and the tab bar are all derived
  // from TAX below. The hardcoded *_FALLBACK objects are only used if that
  // snippet is missing (graceful degradation), never in normal operation.
  const TAX = (function () {
    try {
      const node = document.querySelector('[data-gt-taxonomy]');
      return node ? JSON.parse(node.textContent) : null;
    } catch (_e) { return null; }
  })() || { vts: [], systems: [] };

  const META_FALLBACK = {
    motor_sogutma: {
      title: "Motor Soğutma Sistemi",
      desc: "Radyatör, davlumbaz, genleşme tankı, fan, sensör ve yağ soğutucu parçaları.",
      subs: [
        { key: "radyator_plastik_tank",   label: "Radyatör Plastik Tankı",                          img: (ICON.radyator_plastik_tank||{}).url, bg: (ICON.radyator_plastik_tank||{}).color },
        { key: "davlumbaz_cemberi",       label: "Davlumbaz Çemberi",                                img: (ICON.davlumbaz_cemberi||{}).url, bg: (ICON.davlumbaz_cemberi||{}).color },
        { key: "genlesme_tanki",          label: "Genleşme Tankı",                                   img: (ICON.genlesme_tanki||{}).url, bg: (ICON.genlesme_tanki||{}).color },
        { key: "fan",                     label: "Fan",                                              img: (ICON.fan||{}).url, bg: (ICON.fan||{}).color },
        { key: "sicaklik_sensoru",        label: "Sıcaklık Sensörü",                                 img: (ICON.sicaklik_sensoru||{}).url, bg: (ICON.sicaklik_sensoru||{}).color },
        { key: "radyator_kapagi",         label: "Radyatör Kapağı",                                  img: (ICON.radyator_kapagi||{}).url, bg: (ICON.radyator_kapagi||{}).color },
        { key: "genlesme_tank_kapagi",    label: "Genleşme Tank Kapağı",                             img: (ICON.genlesme_tank_kapagi||{}).url, bg: (ICON.genlesme_tank_kapagi||{}).color },
        { key: "yag_sogutucu_muhafazasi", label: "Yağ Soğutucusu Muhafazası ve Parçaları",           img: (ICON.yag_sogutucu_muhafazasi||{}).url, bg: (ICON.yag_sogutucu_muhafazasi||{}).color },
        { key: "termostat_parcalari",     label: "Termostat Parçaları",                              img: (ICON.termostat_parcalari||{}).url, bg: (ICON.termostat_parcalari||{}).color },
      ]
    },
    motor_yaglama: {
      title: "Motor Yağlama Sistemi",
      desc: "Yağ karteri, conta, tapa, vida, yağ soğutucu parçaları, sensör ve külbütor kapağı.",
      subs: [
        { key: "yag_karteri",                  label: "Yağ Karteri",                                 img: (ICON.yag_karteri||{}).url, bg: (ICON.yag_karteri||{}).color },
        { key: "yag_karteri_vidasi",           label: "Yağ Karteri Vidası",                          img: (ICON.yag_karteri_vidasi||{}).url, bg: (ICON.yag_karteri_vidasi||{}).color },
        { key: "yag_karteri_tapasi",           label: "Yağ Karteri Tapası",                          img: (ICON.yag_karteri_tapasi||{}).url, bg: (ICON.yag_karteri_tapasi||{}).color },
        { key: "yag_karteri_contasi",          label: "Yağ Karteri Contası",                         img: (ICON.yag_karteri_contasi||{}).url, bg: (ICON.yag_karteri_contasi||{}).color },
        { key: "yag_sogutucu_muhafazasi",      label: "Yağ Soğutucusu Muhafazası ve Parçaları",      img: (ICON.yag_sogutucu_muhafazasi||{}).url, bg: (ICON.yag_sogutucu_muhafazasi||{}).color },
        { key: "yag_sogutucu_kapagi",          label: "Yağ Soğutucusu Kapağı ve Parçaları",          img: (ICON.yag_sogutucu_kapagi||{}).url, bg: (ICON.yag_sogutucu_kapagi||{}).color },
        { key: "yag_seviye_sicaklik_sensoru",  label: "Yağ Seviye Sıcaklık Sensörü",                 img: (ICON.yag_seviye_sicaklik_sensoru||{}).url, bg: (ICON.yag_seviye_sicaklik_sensoru||{}).color },
        { key: "kulbutor_kapagi",              label: "Külbütor / Supap / Silindir Kapağı",          img: (ICON.kulbutor_kapagi||{}).url, bg: (ICON.kulbutor_kapagi||{}).color },
      ]
    },
    cam_silecek: {
      title: "Cam Yıkama ve Silecek Sistemi",
      desc: "Silecek suyu deposu ve yıkama pompası.",
      subs: [
        { key: "silecek_suyu_deposu", label: "Silecek Suyu Deposu", img: (ICON.silecek_suyu_deposu||{}).url, bg: (ICON.silecek_suyu_deposu||{}).color },
        { key: "yikama_pompasi",      label: "Yıkama Pompası",      img: (ICON.yikama_pompasi||{}).url, bg: (ICON.yikama_pompasi||{}).color },
        { key: "cam_suyu_doldurma_bogazi", label: "Cam Suyu Deposu Doldurma Boğazı", img: '', bg: '' },
      ]
    },
    hidrolik_direksiyon: {
      title: "Hidrolik Direksiyon Sistemi",
      desc: "Hidrolik direksiyon deposu ve depoya bağlı kapak, sensör, çubuk, filtre ve yay.",
      subs: [
        { key: "hd_deposu",          label: "Hidrolik Direksiyon Deposu",          img: (ICON.hd_deposu||{}).url, bg: (ICON.hd_deposu||{}).color },
        { key: "hd_deposu_kapagi",   label: "Hidrolik Direksiyon Deposu Kapağı",   img: (ICON.hd_deposu_kapagi||{}).url, bg: (ICON.hd_deposu_kapagi||{}).color },
        { key: "hd_deposu_sensoru",  label: "Hidrolik Direksiyon Deposu Sensörü",  img: (ICON.hd_deposu_sensoru||{}).url, bg: (ICON.hd_deposu_sensoru||{}).color },
        { key: "hd_deposu_cubugu",   label: "Hidrolik Direksiyon Deposu Çubuğu",   img: (ICON.hd_deposu_cubugu||{}).url, bg: (ICON.hd_deposu_cubugu||{}).color },
        { key: "hd_deposu_filtresi", label: "Hidrolik Direksiyon Deposu Filtresi", img: (ICON.hd_deposu_filtresi||{}).url, bg: (ICON.hd_deposu_filtresi||{}).color },
        { key: "hd_deposu_yayi",     label: "Hidrolik Direksiyon Deposu Yayı",     img: (ICON.hd_deposu_yayi||{}).url, bg: (ICON.hd_deposu_yayi||{}).color },
      ]
    },
    karoseri: {
      title: "Dış Gövde ve Karoseri Sistemi",
      desc: "Çamurluk, spoiler, hidrolik tutucu kol, doküman kutuları, far çerçevesi ve dış gövde aksamı.",
      subs: [
        { key: "camurluk",            label: "Çamurluk",            img: (ICON.camurluk||{}).url, bg: (ICON.camurluk||{}).color },
        { key: "spoiler",             label: "Spoiler",             img: (ICON.spoiler||{}).url, bg: (ICON.spoiler||{}).color },
        { key: "hidrolik_tutucu_kol", label: "Hidrolik Tutucu Kol", img: (ICON.hidrolik_tutucu_kol||{}).url, bg: (ICON.hidrolik_tutucu_kol||{}).color },
        { key: "dokuman_kutulari",    label: "Doküman Kutuları",    img: (ICON.dokuman_kutulari||{}).url, bg: (ICON.dokuman_kutulari||{}).color },
        { key: "far_cercevesi",       label: "Far Çerçevesi",       img: (ICON.far_cercevesi||{}).url, bg: (ICON.far_cercevesi||{}).color },
        { key: "dis_govde_aksami",    label: "Dış Gövde Aksamı",    img: (ICON.dis_govde_aksami||{}).url, bg: (ICON.dis_govde_aksami||{}).color },
      ]
    },
    yakit: {
      title: "Yakıt Sistemi",
      desc: "Yakıt deposu ve yakıt deposu kapağı.",
      subs: [
        { key: "yakit_deposu",        label: "Yakıt Deposu",        img: (ICON.yakit_deposu||{}).url, bg: (ICON.yakit_deposu||{}).color },
        { key: "yakit_deposu_kapagi", label: "Yakıt Deposu Kapağı", img: (ICON.yakit_deposu_kapagi||{}).url, bg: (ICON.yakit_deposu_kapagi||{}).color },
        { key: "yakit_tortu_kabi",    label: "Yakıt Tortu Kabı",    img: '', bg: '' },
      ]
    },
    egzoz_scr: {
      title: "Egzoz Emisyon Sistemi (SCR)",
      desc: "Üre / AdBlue tankı, magnetli üre dolum adaptörü ve NOx sensörü.",
      subs: [
        { key: "adblue_tanki",       label: "Üre / AdBlue Tankı",         img: (ICON.adblue_tanki||{}).url, bg: (ICON.adblue_tanki||{}).color },
        { key: "ure_dolum_adaptoru", label: "Üre Dolum Adaptörü (Magnetli)", img: (ICON.ure_dolum_adaptoru||{}).url, bg: (ICON.ure_dolum_adaptoru||{}).color },
        { key: "nox_sensoru",        label: "NOx Sensörü",                img: (ICON.nox_sensoru||{}).url, bg: (ICON.nox_sensoru||{}).color },
        { key: "adblue_baglanti_rakoru",        label: "ADBLUE Bağlantı Rakoru",        img: '', bg: '' },
        { key: "adblue_depo_kapagi_miknatisli", label: "Mıknatıslı ADBLUE Depo Kapağı", img: '', bg: '' },
      ]
    },
    karter_pcv: {
      title: "Karter Havalandırma Sistemi",
      desc: "Yağ ayrıştırıcı (oil separator) ve PCV bileşenleri.",
      subs: [
        { key: "yag_ayristirici", label: "Yağ Ayrıştırıcı", img: (ICON.yag_ayristirici||{}).url, bg: (ICON.yag_ayristirici||{}).color },
      ]
    },
    elektrik: {
      title: "Elektrik Sistemi",
      desc: "Akü kapağı, LED aydınlatma ürünleri, sensörler ve sensör yuvası.",
      subs: [
        { key: "aku_kapagi",      label: "Akü Kapağı",              img: (ICON.aku_kapagi||{}).url, bg: (ICON.aku_kapagi||{}).color },
        { key: "led_aydinlatma",  label: "LED Aydınlatma Ürünleri", img: (ICON.led_aydinlatma||{}).url, bg: (ICON.led_aydinlatma||{}).color },
        { key: "sensorler",       label: "Sensörler",               img: (ICON.sensorler||{}).url, bg: (ICON.sensorler||{}).color },
        { key: "sensor_yuvasi",   label: "Sensör Yuvası",           img: (ICON.sensor_yuvasi||{}).url, bg: (ICON.sensor_yuvasi||{}).color },
      ]
    },
    hava_emis: {
      title: "Hava Emiş Sistemi",
      desc: "Hava filtresi kapağı, muhafazası ve ilgili parçalar.",
      subs: [
        { key: "hava_filtresi_kapagi",     label: "Hava Filtresi Kapağı",     img: (ICON.hava_filtresi_kapagi||{}).url,     bg: (ICON.hava_filtresi_kapagi||{}).color },
        { key: "hava_filtresi_muhafazasi", label: "Hava Filtresi Muhafazası", img: (ICON.hava_filtresi_muhafazasi||{}).url, bg: (ICON.hava_filtresi_muhafazasi||{}).color },
        { key: "diger_urunler",            label: "Diğer Ürünler",            img: '', bg: '' },
      ]
    },
    park_sabitleme: {
      title: "Park Sabitleme Sistemi",
      desc: "Tekerlek takozu ve takoz kelepçesi.",
      subs: [
        { key: "takoz",           label: "Takoz",            img: (ICON.takoz||{}).url, bg: (ICON.takoz||{}).color },
        { key: "takoz_kelepcesi", label: "Takoz Kelepçesi",  img: (ICON.takoz_kelepcesi||{}).url, bg: (ICON.takoz_kelepcesi||{}).color },
      ]
    },
    // VT=conta dedicated meta — 11 leaf segments from CSV s6 "Conta, Tapa,
    // Civata ve Filitre / X" paths. Images intentionally omitted so these
    // CSV-derived subs are visually distinct from the established (image-
    // bearing) subs — easier to identify which categories are new.
    ctcf_tum_urunler: {
      title: "Conta, Tapa, Civata ve Filtre",
      desc: "Contalar, tapalar, civatalar, filtreler, kelepçe ve form yay.",
      subs: [
        { key: "contalar",              label: "Contalar",              img: '', bg: '' },
        { key: "tapalar",               label: "Tapalar",               img: '', bg: '' },
        { key: "civatalar",             label: "Civatalar",             img: '', bg: '' },
        { key: "filtre_elemani",        label: "Filtre Elemanı",        img: '', bg: '' },
        { key: "filtre_kapagi",         label: "Filtre Kapağı",         img: '', bg: '' },
        { key: "filtre_suzgeci",        label: "Filtre Süzgeci",        img: '', bg: '' },
        { key: "filtre_borulari",       label: "Filtre Boruları",       img: '', bg: '' },
        { key: "filtre_tasi_korugu",    label: "Filtre Tası Körüğü",    img: '', bg: '' },
        { key: "kelepce",               label: "Kelepçe",               img: '', bg: '' },
        { key: "form_yay",              label: "Form Yay",              img: '', bg: '' },
      ]
    },
    // Traktör/İş Makinesi CSV s6: "Hidrolik Sistem / Genel Hidrolik Sistemi
    // / X" — surfaces the two leaf subs as a standalone meta tab. No images
    // for the same visual-distinction reason as the CTCF subs above.
    hidrolik_sistem: {
      title: "Genel Hidrolik",
      desc: "Fren hidrolik deposu ve hidrolik yağ deposu.",
      subs: [
        { key: "fren_hidrolik_deposu", label: "Fren Hidrolik Deposu", img: '', bg: '' },
        { key: "hidrolik_yag_deposu",  label: "Hidrolik Yağ Deposu",  img: '', bg: '' },
      ]
    }
  };

  // Live META from taxonomy; falls back to the hardcoded map above.
  const META = (TAX.systems && TAX.systems.length)
    ? (function () {
        const o = {};
        TAX.systems.forEach(function (s) {
          o[s.key] = {
            title: s.title,
            desc: s.desc,
            subs: (s.subs || []).map(function (x) { return { key: x.key, label: x.label, img: x.img, bg: x.bg }; }),
          };
        });
        return o;
      })()
    : META_FALLBACK;

  const el = document.getElementById('category-browser');
  if (!el) return;

  // Build the system tab bar from the taxonomy (order + labels come from
  // metaobjects). If taxonomy is unavailable, the static HTML tabs remain.
  (function () {
    const wrap = el.querySelector('.browser__tabs');
    if (wrap && TAX.systems && TAX.systems.length) {
      wrap.innerHTML = '';
      TAX.systems.forEach(function (s, i) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'tab' + (i === 0 ? ' is-active' : '');
        b.setAttribute('data-meta', s.key);
        b.setAttribute('role', 'tab');
        b.textContent = s.tab || s.title || s.key;
        wrap.appendChild(b);
      });
    }
  })();
  const tabs = el.querySelectorAll('.tab');
  const subcatsEl = el.querySelector('[data-subcats]');
  const titleEl = el.querySelector('[data-meta-title]');
  const descEl = el.querySelector('[data-meta-desc]');
  const productsEl = el.querySelector('[data-products]');
  const productsTitle = el.querySelector('[data-products-title]');
  const productsGrid = el.querySelector('[data-product-grid]');
  const productsEmpty = el.querySelector('[data-products-empty]');
  const brandLabel = el.querySelector('[data-brand-label]');
  const backBtn = el.querySelector('[data-back]');

  // Loaded product data keyed by: vtKey → brand → metaKey → subKey → [products]
  // The JSON used to be inlined into the section, but it grew past Shopify's
  // 256 KB per-template limit, so we now fetch it from the assets folder. The
  // empty inline `[data-gt-products-data]` script is kept as a back-compat
  // selector for header.liquid's predictive search seed (it now loads from
  // window.GT_PRODUCTS_DATA after this fetch resolves).
  let PRODUCTS = {};
  let PRODUCTS_READY = false;
  let productsReadyResolve;
  const productsReadyPromise = new Promise((res) => { productsReadyResolve = res; });
  // Expose so other sections (e.g. header search) can await the same fetch
  // instead of doing a duplicate request.
  window.GT_PRODUCTS_DATA_PROMISE = productsReadyPromise;

  (async () => {
    try {
      const url = el.dataset.productsUrl;
      if (!url) throw new Error('Missing data-products-url on category-browser');
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('HTTP ' + res.status + ' loading products data');
      PRODUCTS = await res.json();
      PRODUCTS_READY = true;
      window.GT_PRODUCTS_DATA = PRODUCTS;
      productsReadyResolve(PRODUCTS);
      // Tab count badges and the currently open subcat grid both depend on
      // PRODUCTS, so refresh both once data arrives. Empty subcats are now
      // hidden by renderSubcatBtn, so this is also what reveals the right
      // set of thumbnails for the active brand.
      try { applyTabCounts(); } catch (_e) {}
      try { renderMeta(currentMetaKey); } catch (_e) {}
    } catch (err) {
      console.error('Failed to load product data', err);
      productsReadyResolve({});
    }
  })();

  // Currently selected vehicle type & brand
  let currentVtKey = null;
  let currentBrand = null;
  let currentMetaKey = 'motor_sogutma';

  function productsFor(metaKey, subKey) {
    if (!PRODUCTS_READY) return [];

    // Brand + vehicle type selected → narrow lookup
    if (currentVtKey && currentBrand) {
      const vt = PRODUCTS[currentVtKey];
      if (!vt) return [];
      const b = vt[currentBrand];
      if (!b) return [];
      const m = b[metaKey];
      if (!m) return [];
      return m[subKey] || [];
    }

    // No brand selected → aggregate across all vt/brand, deduped by handle
    const seen = new Set();
    const out = [];
    for (const vtKey in PRODUCTS) {
      const vt = PRODUCTS[vtKey];
      for (const brand in vt) {
        const m = vt[brand][metaKey];
        if (!m) continue;
        const list = m[subKey];
        if (!list) continue;
        for (const p of list) {
          const k = p.handle || JSON.stringify(p);
          if (seen.has(k)) continue;
          seen.add(k);
          out.push(p);
        }
      }
    }
    return out;
  }

  function countFor(metaKey, subKey) {
    return productsFor(metaKey, subKey).length;
  }

  // Total product count for a parent meta key (sum of all its subs)
  function metaTotalCount(metaKey) {
    const m = META[metaKey];
    if (!m) return 0;
    return m.subs.reduce((n, s) => n + countFor(metaKey, s.key), 0);
  }

  // Show count badges and (once a brand is selected) hide empty tabs so
  // each VT only surfaces the systems that actually contain products.
  // Before a brand is picked every count is 0, so we leave all tabs visible
  // — except `ctcf_tum_urunler`, which only makes sense under VT=conta.
  function applyTabCounts() {
    const hasSelection = !!currentBrand;
    tabs.forEach(t => {
      const baseLabel = t.dataset.baseLabel || t.textContent.trim();
      t.dataset.baseLabel = baseLabel;
      const n = metaTotalCount(t.dataset.meta);
      t.textContent = `${baseLabel} (${n})`;
      if (t.dataset.meta === 'ctcf_tum_urunler') {
        t.hidden = n === 0;
      } else {
        t.hidden = hasSelection && n === 0;
      }
    });
  }

  // Pick the meta of the first non-hidden tab — used when switching VT/brand
  // so we default to a meta that actually has products (e.g. VT=conta lands
  // on `ctcf_tum_urunler` instead of empty motor_sogutma).
  function firstVisibleMeta() {
    for (const t of tabs) if (!t.hidden) return t.dataset.meta;
    return tabs[0]?.dataset.meta || null;
  }

  function renderMeta(key) {
    currentMetaKey = key;
    const m = META[key];
    if (!m) return;

    const swap = () => {
      titleEl.textContent = m.title;
      descEl.textContent = m.desc;
      subcatsEl.innerHTML = '';
      m.subs.forEach(renderSubcatBtn);
      productsEl.hidden = true;
      subcatsEl.hidden = false;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => subcatsEl.classList.remove('is-leaving'));
      });
    };

    // If something is already visible, fade it out before swapping
    if (!subcatsEl.hidden && subcatsEl.innerHTML.trim() !== '') {
      subcatsEl.classList.add('is-leaving');
      setTimeout(swap, 160);
    } else if (!productsEl.hidden) {
      productsEl.classList.add('is-leaving');
      setTimeout(() => {
        productsEl.hidden = true;
        productsEl.classList.remove('is-leaving');
        subcatsEl.classList.add('is-leaving');
        swap();
      }, 160);
    } else {
      swap();
    }
  }

  function renderSubcatBtn_unused() {
    // placeholder — real function defined below
  }

  // Extracted subcat button builder so renderMeta can call it.
  // Subcategories with zero products are skipped — the parent meta tab is
  // already auto-hidden when its total hits 0 (see applyTabCounts), so this
  // covers the inner-tile case where the meta has some non-empty subs and
  // some empty ones. If every sub is 0, the meta tab won't be clickable.
  function renderSubcatBtn(s) {
    const count = countFor(currentMetaKey, s.key);
    if (count === 0) return;
    const btn = document.createElement('button');
    btn.className = 'subcat';
    btn.setAttribute('data-key', s.key);
    const img = s.img || '';
    // No image → render a compact label-only tile so brand-new CSV-derived
    // subs are visually distinct from established image tiles.
    const imgHtml = img ? `<div class="subcat__img" style="background-image:url('${img}')"></div>` : '';
    if (!img) btn.classList.add('subcat--no-img');
    btn.innerHTML = `
        ${imgHtml}
        <div class="subcat__label"><span>${s.label} <span class="subcat__count">(${count})</span></span><span class="subcat__arrow">→</span></div>
      `;
    btn.addEventListener('click', () => showProducts(currentMetaKey, s));
    subcatsEl.appendChild(btn);
  }

  function _origRenderMeta_unused(key) {
    const m = META[key];
    m.subs.forEach(s => {
      const btn = document.createElement('button');
      btn.className = 'subcat';
      const count = countFor(key, s.key);
      btn.innerHTML = `
        <div class="subcat__img" style="background-image:url('${s.img}')"></div>
        <div class="subcat__label"><span>${s.label} <span class="subcat__count">(${count})</span></span><span class="subcat__arrow">→</span></div>
      `;
      btn.addEventListener('click', () => showProducts(key, s));
      subcatsEl.appendChild(btn);
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  const IMG_FALLBACK_SVG = '<div class="pcard__img-fallback" aria-hidden="true"><svg viewBox="0 0 60 60" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="8" width="44" height="44" rx="4"/><circle cx="20" cy="22" r="3"/><path d="M8 40l12-12 10 10 8-8 14 14"/></svg></div>';
  const CTA_MINUS_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
  const CTA_PLUS_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
  // Blue sunburst "sale" sticker — MUST match snippets/discount-badge.liquid.
  const saleBadgeSvg = (pct) => `<span class="gt-sale" aria-hidden="true"><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><defs><linearGradient id="gtSaleR" x1="0.2" y1="0" x2="0.8" y2="1"><stop offset="0" stop-color="#3f8bf7"/><stop offset="1" stop-color="#1349b8"/></linearGradient><radialGradient id="gtSaleC" cx="38%" cy="32%" r="78%"><stop offset="0" stop-color="#6aa9ff"/><stop offset="58%" stop-color="#3580f0"/><stop offset="1" stop-color="#1f60d8"/></radialGradient></defs><circle cx="50.00" cy="7.00" r="5.6" fill="url(#gtSaleR)"/><circle cx="69.98" cy="11.93" r="5.6" fill="url(#gtSaleR)"/><circle cx="85.39" cy="25.57" r="5.6" fill="url(#gtSaleR)"/><circle cx="92.69" cy="44.82" r="5.6" fill="url(#gtSaleR)"/><circle cx="90.21" cy="65.25" r="5.6" fill="url(#gtSaleR)"/><circle cx="78.51" cy="82.19" r="5.6" fill="url(#gtSaleR)"/><circle cx="60.29" cy="91.75" r="5.6" fill="url(#gtSaleR)"/><circle cx="39.71" cy="91.75" r="5.6" fill="url(#gtSaleR)"/><circle cx="21.49" cy="82.19" r="5.6" fill="url(#gtSaleR)"/><circle cx="9.79" cy="65.25" r="5.6" fill="url(#gtSaleR)"/><circle cx="7.31" cy="44.82" r="5.6" fill="url(#gtSaleR)"/><circle cx="14.61" cy="25.57" r="5.6" fill="url(#gtSaleR)"/><circle cx="30.02" cy="11.93" r="5.6" fill="url(#gtSaleR)"/><circle cx="50" cy="50" r="42" fill="url(#gtSaleR)"/><circle cx="50" cy="50" r="34" fill="url(#gtSaleC)"/><circle cx="50" cy="50" r="34" fill="none" stroke="#ffffff" stroke-opacity="0.5" stroke-width="1.4"/><ellipse cx="40" cy="31" rx="22" ry="12" fill="#fff" opacity="0.16"/><text x="50" y="60" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-weight="800" fill="#fff" letter-spacing="-1.2"><tspan font-size="19" dy="-0.5">%</tspan><tspan font-size="33" dy="0.5">${pct}</tspan></text></svg></span>`;

  // handle → { price, compare_at_price, vendor, available } from Shopify.
  // Hydrated from /products.json (shared cache with header search) so cards
  // can show real prices & vendors just like the best-sellers pcard.
  const SHOPIFY_INFO = new Map();
  let SHOPIFY_INFO_READY = false;
  let SHOPIFY_INFO_PROMISE = null;

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    const n = Number(cents);
    const symbol = el.dataset.currencySymbol || '₺';
    const amount = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return symbol + amount;
  }

  function ingestShopifyProducts(list) {
    for (const p of list || []) {
      if (!p || !p.handle) continue;
      const v = (p.variants && p.variants[0]) || {};
      const price = v.price != null ? parseFloat(v.price) : null;
      const cap = v.compare_at_price != null ? parseFloat(v.compare_at_price) : null;
      SHOPIFY_INFO.set(p.handle, {
        price: price,
        compare_at_price: cap,
        variant_id: v.id || null,
        vendor: p.vendor || '',
        available: !!v.available
      });
    }
  }

  async function loadShopifyInfo() {
    if (SHOPIFY_INFO_READY) return;
    if (SHOPIFY_INFO_PROMISE) return SHOPIFY_INFO_PROMISE;
    SHOPIFY_INFO_PROMISE = (async () => {
      try {
        const cached = sessionStorage.getItem('gt-products-json');
        if (cached) {
          try { ingestShopifyProducts(JSON.parse(cached)); } catch (_e) {}
        }
        for (let page = 1; page <= 4; page++) {
          const res = await fetch('/products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } });
          if (!res.ok) break;
          const data = await res.json();
          const list = (data && data.products) || [];
          if (!list.length) break;
          ingestShopifyProducts(list);
          if (list.length < 250) break;
        }
        SHOPIFY_INFO_READY = true;
      } catch (err) { console.warn('category-browser: products.json fetch failed', err); }
    })();
    return SHOPIFY_INFO_PROMISE;
  }

  function shopifyImg(url, width) {
    if (!url) return '';
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (_e) { return url; }
  }

  function cleanTitle(t) {
    return String(t == null ? '' : t).replace(/^[\s*]+/, '').trim();
  }

  // Build a `pcard`-shaped card from our JSON data. Pulls the real price &
  // vendor from Shopify when available (loadShopifyInfo has hydrated the
  // SHOPIFY_INFO map); otherwise falls back to brand name + OEM/Ref placeholder.
  function buildCard(p) {
    const title = escapeHtml(cleanTitle(p.title || p.handle));
    const href = p.handle ? `/products/${p.handle}` : '#';
    let media;
    if (p.image) {
      const src300 = shopifyImg(p.image, 300);
      const src600 = shopifyImg(p.image, 600);
      const src900 = shopifyImg(p.image, 900);
      media = `<div class="pcard__img-wrap"><img class="pcard__img" src="${src600}" srcset="${src300} 300w, ${src600} 600w, ${src900} 900w" sizes="(max-width: 640px) 80vw, 300px" loading="lazy" alt="${title}"></div>`;
    } else {
      media = `<div class="pcard__img-wrap">${IMG_FALLBACK_SVG}</div>`;
    }

    const info = SHOPIFY_INFO.get(p.handle);
    const vendorName = (info && info.vendor) || currentBrand || '';
    // First OEM code. Handles Mercedes-style "A003 205 01 06" (one code with
    // internal spaces) vs "1676319 20503362" (two distinct codes).
    let oemCode = '';
    if (p.oem) {
      const r = String(p.oem).split(/[|,]/)[0].trim();
      const t = r.split(/\s+/).filter(Boolean);
      oemCode = (t.length >= 2 && !(t[0].length <= 4 && t[1].length <= 4)) ? t[0] : r;
    }
    const oemTag = oemCode ? `<span class="pcard__oem">${escapeHtml(oemCode)}</span>` : '';
    const vendor = (vendorName || oemTag)
      ? `<div class="pcard__meta"><span class="pcard__vendor">${escapeHtml(vendorName)}</span>${oemTag}</div>`
      : '';

    let priceHtml;
    if (info && info.price != null && !isNaN(info.price)) {
      const showOld = info.compare_at_price && info.compare_at_price > info.price;
      priceHtml = (showOld ? `<span class="pcard__price-old" data-gt-amt="${Math.round(info.compare_at_price * 100)}">${money(info.compare_at_price)}</span>` : '')
        + `<span class="pcard__price-now" data-gt-amt="${Math.round(info.price * 100)}">${money(info.price)}</span>`;
    } else {
      priceHtml = `<span class="pcard__price-now pcard__price-now--muted">—</span>`;
    }

    const onSale = info && info.price > 0 && info.compare_at_price && info.compare_at_price > info.price;
    const saleBadge = onSale ? saleBadgeSvg(Math.round((info.compare_at_price - info.price) / info.compare_at_price * 100)) : '';
    const soldOut = info && !info.available ? `<span class="pcard__badge pcard__badge--out">Stokta yok</span>` : '';
    const stockOutChip = info && !info.available ? `<span class="pcard__stock-out" role="status"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="13"/><circle cx="12" cy="16.2" r="0.4" fill="currentColor"/></svg>Stokta yok</span>` : '';
    const variantId = info && info.variant_id ? escapeHtml(String(info.variant_id)) : '';
    const canBuy = info && info.available && variantId;
    const cta = canBuy
      ? `<span class="pcard__cta" data-cta data-handle="${escapeHtml(p.handle || '')}" data-variant-id="${variantId}" data-count="0" role="group" aria-label="Sepet adedi"><span class="pcard__cta-btn pcard__cta-btn--minus" data-minus role="button" aria-label="Azalt" tabindex="-1">${CTA_MINUS_SVG}</span><span class="pcard__cta-count" data-count-display>0</span><span class="pcard__cta-btn pcard__cta-btn--plus" data-plus role="button" aria-label="Sepete ekle" tabindex="0">${CTA_PLUS_SVG}</span></span>`
      : '';
    const actions = canBuy
      ? `<div class="pcard__actions"><span class="pcard__go-cart" data-go-cart role="button" tabindex="0" aria-label="Sepete git">Sepete Git</span><span class="pcard__buy" data-buy-now data-variant-id="${variantId}" role="button" tabindex="0" aria-label="Hemen al">Hemen Al</span></div>`
      : '';

    return `<a class="pcard" href="${href}"><figure class="pcard__media">${media}${soldOut}${saleBadge}</figure><div class="pcard__body">${vendor}<h3 class="pcard__title">${title}</h3>${stockOutChip}<div class="pcard__foot"><div class="pcard__price">${priceHtml}</div>${cta}</div>${actions}</div></a>`;
  }

  function renderProductCards(items) {
    productsGrid.innerHTML = '';
    if (!items.length) {
      productsEmpty.hidden = false;
      return;
    }
    const parts = [];
    for (const p of items) {
      if (!p) continue;
      parts.push(buildCard(p));
    }
    if (!parts.length) {
      productsEmpty.hidden = false;
      return;
    }
    productsEmpty.hidden = true;
    productsGrid.innerHTML = parts.join('');
  }

  function showProducts(metaKey, sub) {
    productsTitle.textContent = sub.label;
    subcatsEl.hidden = true;
    productsEl.hidden = false;
    const items = productsFor(metaKey, sub.key);
    renderProductCards(items);
    scrollBrowserToTop();
    // Once Shopify data arrives, re-render the same list so prices/vendor appear.
    loadShopifyInfo().then(() => renderProductCards(items));
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // Pin the page's scroll position around the swap. renderMeta wipes the
      // subcats grid (innerHTML = '') and re-renders, which collapses the
      // layout briefly and lets the browser shift the user's view. Hold the
      // scroll where it was so tab-switching feels in-place.
      const savedY = window.scrollY;
      tabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');
      renderMeta(tab.dataset.meta);
      // Force scroll back across the next few frames + after the 160ms fade
      // transition completes. Using rAF + a backstop timeout covers both
      // immediate layout reflows and the post-transition swap.
      requestAnimationFrame(() => window.scrollTo(0, savedY));
      setTimeout(() => window.scrollTo(0, savedY), 220);
    });
  });

  // Smooth swap: products view ↔ subcats
  function scrollBrowserToTop() {
    // Target the meta heading row (.browser__title) so the user lands on
    // "Motor Soğutma Sistemi" + its description rather than the selector +
    // tab strip. Offset = sticky header (~68px) + ~60px breathing room so
    // the heading isn't flush against the bottom edge of the sticky bar.
    const target = el.querySelector('.browser__title') || el;
    const top = target.getBoundingClientRect().top + window.scrollY - 128;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }
  function showSubcatsAnim() {
    if (productsEl.hidden) return;
    scrollBrowserToTop();
    productsEl.classList.add('is-leaving');
    setTimeout(() => {
      productsEl.hidden = true;
      productsEl.classList.remove('is-leaving');
      subcatsEl.hidden = false;
      subcatsEl.classList.add('is-leaving');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => subcatsEl.classList.remove('is-leaving'));
      });
    }, 260);
  }
  backBtn.addEventListener('click', () => {
    showSubcatsAnim();
    // Scroll the section's header into view so the user lands above the
    // "Araç ve marka seç" selector (clears sticky header + leaves breathing
    // room above the heading).
    const target = el.querySelector('.browser__head') || el;
    const top = target.getBoundingClientRect().top + window.scrollY - 110;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });

  // ==== Vehicle/brand selector (in-browser directory picker) ====
  const BROWSER_DATA_FALLBACK = {
    agir: { label: "Ağır Vasıta, Otobüs", brands: ["Mercedes", "MAN", "IVECO", "DAF", "SCANIA", "VOLVO", "RENAULT", "American Trucks", "KAMAZ", "IFA W50 Multicar", "Ford", "BMC", "Otokar", "Chrysler"] },
    hafif: { label: "Hafif Ticari, Binek, Japon Grubu", brands: ["BMW", "ISUZU", "KIA", "MITSUBISHI", "NISSAN", "Hyundai", "VOLKSWAGEN", "TOYOTA", "JEEP", "Range Rover"] },
    traktor: { label: "Traktör", brands: ["Massey Ferguson", "John Deere", "Claas", "New Holland", "Fendt", "AGCO", "Fiat", "Ford", "Case IH", "Deutz", "Steyr", "Kubota", "Türk Traktör", "Tümosan", "Kademe", "Erkunt", "Başak", "Hattat", "İhi-shibaura (İşbora)", "Laverda", "Zetor", "Valtra"] },
    isMakinasi: { label: "İş Makinası", brands: ["JCB", "Caterpillar", "Alvano", "Alborz", "Batsan", "Bobcat", "Foton", "Hitachi", "Howo", "Komatsu", "MAZ", "Maxima", "VOLVO", "Hidromek", "Cummins", "Perkins"] },
    dorseTrailer: { label: "Dorse, Trailer", brands: ["Genel Ürünler", "Webasto"] },
    hidrolikDepo: { label: "Hidrolik Direksiyon Deposu", brands: ["Tüm Hidrolik Direksiyon Depoları"] },
    "jeneratör": { label: "Jeneratör", brands: ["Genel Ürünler", "Hidromek", "Cummins", "Perkins"] },
    endustriyel: { label: "Endüstriyel", brands: ["Tüm Endüstriyel"] },
    aluminyumGobek: { label: "Alüminyum Göbek, Fan Kanadı", brands: ["Tüm Alüminyum Göbek / Fan Kanadı"] },
    conta: { label: "Conta, Tapa, Civata, Filtre", brands: ["Tüm Conta Tapa Civata ve Filtre"] },
    kapak: { label: "Kapak", brands: ["Tüm Kapaklar"] },
    sensor: { label: "Sensör", brands: ["Tüm Sensörler"] },
    universal: { label: "Üniversal", brands: ["Üniversal"] },
    diger: { label: "Diğer", brands: ["Diğer Ürünler"] }
  };

  // Live BROWSER_DATA (vt -> {label, brands}) from taxonomy; hardcoded fallback.
  const BROWSER_DATA = (TAX.vts && TAX.vts.length)
    ? (function () {
        const o = {};
        TAX.vts.forEach(function (vt) { o[vt.key] = { label: vt.label, brands: (vt.brands || []).slice() }; });
        return o;
      })()
    : BROWSER_DATA_FALLBACK;

  const selectorEl = el.querySelector('[data-selector]');
  const selectorToggle = el.querySelector('[data-selector-toggle]');
  const selectorLabel = el.querySelector('[data-selector-toggle-label]');
  const vtListEl = el.querySelector('[data-selector-vts]');
  const brandListEl = el.querySelector('[data-selector-brands]');
  const brandHeadEl = el.querySelector('[data-selector-brand-head]');
  const selectorEmptyEl = el.querySelector('[data-selector-empty]');

  // Custom always-visible scrollbar — defined inline (idempotent IIFE shared
  // with header.liquid; whichever section loads first wins). The dropdown
  // starts hidden, so we re-measure on every open via openSelector().
  (function () {
    if (window.gtAttachCustomScrollbar) return;
    window.gtAttachCustomScrollbar = function (scrollEl) {
      if (!scrollEl) return function () {};
      if (scrollEl.dataset.cscrollAttached === '1') return scrollEl.__cscrollRefresh || function () {};
      scrollEl.dataset.cscrollAttached = '1';
      scrollEl.classList.add('gt-cscroll-host');
      var p = scrollEl.parentNode;
      if (getComputedStyle(p).position === 'static') p.style.position = 'relative';
      var bar = document.createElement('div');
      bar.className = 'gt-cscroll';
      var thumb = document.createElement('div');
      thumb.className = 'gt-cscroll__thumb';
      bar.appendChild(thumb);
      p.appendChild(bar);
      function position() {
        var c = scrollEl.getBoundingClientRect();
        var pr = p.getBoundingClientRect();
        if (c.width === 0 || c.height === 0) { bar.style.display = 'none'; return false; }
        bar.style.display = 'block';
        bar.style.top = (c.top - pr.top + 6) + 'px';
        bar.style.left = (c.right - pr.left - 14) + 'px';
        bar.style.height = (c.height - 12) + 'px';
        return true;
      }
      function update() {
        if (!position()) return;
        var ch = scrollEl.scrollHeight, vh = scrollEl.clientHeight;
        if (ch <= vh + 1) { bar.dataset.empty = 'true'; return; }
        bar.dataset.empty = 'false';
        var th = bar.clientHeight, ratio = vh / ch;
        var thumbH = Math.max(28, th * ratio);
        var maxScroll = ch - vh, maxThumb = th - thumbH;
        var t = maxScroll > 0 ? (scrollEl.scrollTop / maxScroll) * maxThumb : 0;
        thumb.style.height = thumbH + 'px';
        thumb.style.transform = 'translateY(' + t + 'px)';
      }
      function refresh() { requestAnimationFrame(update); }
      scrollEl.__cscrollRefresh = refresh;
      scrollEl.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', refresh);
      if (typeof ResizeObserver !== 'undefined') {
        try { new ResizeObserver(refresh).observe(scrollEl); } catch (_) {}
      }
      var dragStart = null;
      thumb.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        try { thumb.setPointerCapture(e.pointerId); } catch (_) {}
        thumb.classList.add('is-dragging');
        dragStart = { y: e.clientY, scrollTop: scrollEl.scrollTop };
      });
      thumb.addEventListener('pointermove', function (e) {
        if (!dragStart) return;
        var th = bar.clientHeight, thumbH = thumb.clientHeight, maxThumb = th - thumbH;
        if (maxThumb <= 0) return;
        var dy = e.clientY - dragStart.y;
        var maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
        scrollEl.scrollTop = dragStart.scrollTop + (dy / maxThumb) * maxScroll;
      });
      function endDrag() { dragStart = null; thumb.classList.remove('is-dragging'); }
      thumb.addEventListener('pointerup', endDrag);
      thumb.addEventListener('pointercancel', endDrag);
      thumb.addEventListener('lostpointercapture', endDrag);
      bar.addEventListener('mousedown', function (e) {
        if (e.target === thumb) return;
        var rect = bar.getBoundingClientRect();
        var clickY = e.clientY - rect.top;
        var th = bar.clientHeight, thumbH = thumb.clientHeight, maxThumb = th - thumbH;
        var maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
        if (maxThumb <= 0) return;
        var target = Math.max(0, Math.min(maxThumb, clickY - thumbH / 2));
        scrollEl.scrollTo({ top: (target / maxThumb) * maxScroll, behavior: 'smooth' });
      });
      requestAnimationFrame(update);
      setTimeout(update, 120);
      return refresh;
    };
  })();

  const selectorVtCol = selectorEl && selectorEl.querySelector('.selector__col:first-child');
  let selectorVtRefresh = null;
  if (selectorVtCol) selectorVtRefresh = window.gtAttachCustomScrollbar(selectorVtCol);

  let selectorActiveVt = null;

  function openSelector() {
    selectorEl.classList.add('is-open');
    selectorToggle.setAttribute('aria-expanded', 'true');
    if (selectorVtRefresh) selectorVtRefresh();
  }
  function closeSelector() {
    selectorEl.classList.remove('is-open');
    selectorToggle.setAttribute('aria-expanded', 'false');
  }

  function renderVtList() {
    vtListEl.innerHTML = '';
    Object.entries(BROWSER_DATA).forEach(([key, vt]) => {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.dataset.vtKey = key;
      btn.textContent = vt.label;
      if (key === selectorActiveVt) btn.classList.add('is-active');
      btn.addEventListener('click', () => renderBrandListFor(key));
      li.appendChild(btn);
      vtListEl.appendChild(li);
    });
    // "Tüm Ürünler" — direct select, no brand drill-down
    const allLi = document.createElement('li');
    const allBtn = document.createElement('button');
    allBtn.type = 'button';
    allBtn.className = 'selector__all';
    allBtn.textContent = 'Tüm Ürünler';
    allBtn.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('garantiteknik:brand-selected', {
        detail: { vtKey: null, brand: null, label: 'Tüm Ürünler' }
      }));
      closeSelector();
    });
    allLi.appendChild(allBtn);
    vtListEl.appendChild(allLi);
  }

  function renderBrandListFor(key) {
    selectorActiveVt = key;
    vtListEl.querySelectorAll('button').forEach((b) => {
      b.classList.toggle('is-active', b.dataset.vtKey === key);
    });
    const vt = BROWSER_DATA[key];
    brandHeadEl.textContent = vt.label + ' — Marka';
    brandListEl.innerHTML = '';
    vt.brands.forEach((b) => {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = b;
      btn.addEventListener('click', () => pickBrand(key, b));
      li.appendChild(btn);
      brandListEl.appendChild(li);
    });
    brandListEl.hidden = false;
    selectorEmptyEl.hidden = true;
  }

  function pickBrand(vtKey, brand) {
    const vt = BROWSER_DATA[vtKey];
    document.dispatchEvent(new CustomEvent('garantiteknik:brand-selected', {
      detail: { vtKey, brand, label: vt.label + ' › ' + brand }
    }));
    closeSelector();
  }

  selectorToggle.addEventListener('click', () => {
    if (selectorEl.classList.contains('is-open')) closeSelector();
    else openSelector();
  });

  renderVtList();

  // Close selector when clicking outside
  document.addEventListener('click', (e) => {
    if (!selectorEl.contains(e.target) && !selectorToggle.contains(e.target)) {
      closeSelector();
    }
  });

  // Listen for brand selection (from mega menu OR in-browser selector)
  document.addEventListener('garantiteknik:brand-selected', (e) => {
    currentVtKey = e.detail.vtKey || null;
    currentBrand = e.detail.brand || null;
    brandLabel.textContent = e.detail.label || e.detail.brand || 'Marka Seçilmedi';
    // Toggle button label stays as "Araç ve marka seç" even after a brand
    // is picked — the user wants a stable affordance, not a state-change.

    applyTabCounts();
    const firstMeta = firstVisibleMeta() || 'motor_sogutma';
    tabs.forEach(t => t.classList.toggle('is-active', t.dataset.meta === firstMeta));
    renderMeta(firstMeta);
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Default render (no brand yet — show base tabs, no counts)
  applyTabCounts();
  renderMeta('motor_sogutma');

  // If URL has ?vt=<key>, open selector and show that vt's brands immediately
  (function () {
    try {
      const params = new URLSearchParams(window.location.search);
      const vtParam = params.get('vt');
      const brandParam = params.get('brand');
      if (params.get('all') === '1') {
        document.dispatchEvent(new CustomEvent('garantiteknik:brand-selected', {
          detail: { vtKey: null, brand: null, label: 'Tüm Ürünler' }
        }));
      } else if (vtParam && brandParam && BROWSER_DATA[vtParam]) {
        pickBrand(vtParam, brandParam);
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
      } else if (vtParam && BROWSER_DATA[vtParam]) {
        openSelector();
        renderBrandListFor(vtParam);
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
      }
    } catch (_) {}
  })();
  // Warm the Shopify price/vendor cache in the background so the first
  // subcategory click already has data to hydrate cards with.
  loadShopifyInfo();
  } catch (err) {
    console.warn('category-browser init failed:', err);
  }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Newsletter signup — stays on the same page. On success, hide the form and
  // show a simple "submitted" banner. No captcha redirect, no placeholder
  // swap. If user wants to subscribe another email they can refresh.
  (function () {
    const wrap = document.querySelector('[data-footer-nl]');
    if (!wrap) return;
    const form = wrap.querySelector('form.footer__nl-form');
    const input = wrap.querySelector('[data-nl-input]');
    const thanks = wrap.querySelector('[data-nl-thanks]');
    const posted = wrap.querySelector('[data-nl-posted]');
    if (!form || !input || !thanks) return;

    function showThanks() {
      form.style.display = 'none';
      thanks.hidden = false;
      requestAnimationFrame(() => thanks.classList.add('is-visible'));
    }

    function showError() {
      form.classList.add('is-err');
      setTimeout(() => form.classList.remove('is-err'), 2200);
    }

    // If user returned from Shopify's challenge/captcha redirect with
    // customer_posted=true, show the banner and scroll it into view — the
    // browser lands at the top of the page by default, so the user wouldn't
    // see the footer banner otherwise.
    function scrollToBanner() {
      setTimeout(() => {
        thanks.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 150);
    }

    const url = new URL(window.location.href);
    const cameBackFromSubmit = !!posted || url.searchParams.has('customer_posted');
    if (cameBackFromSubmit) {
      showThanks();
      scrollToBanner();
      if (url.searchParams.has('customer_posted')) {
        url.searchParams.delete('customer_posted');
        url.searchParams.delete('form_type');
        window.history.replaceState({}, document.title, url.pathname + (url.search ? url.search : '') + url.hash);
      }
    }

    // Mobile-only accordion toggle for footer link columns. On desktop the
    // chevron is hidden via CSS and lists are always visible regardless of
    // aria-expanded state, so the click is a harmless no-op there.
    const mq = window.matchMedia('(max-width: 600px)');
    document.querySelectorAll('[data-footer-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!mq.matches) return;
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!input.value || !input.checkValidity()) { input.reportValidity(); return; }
      form.classList.remove('is-err');
      form.classList.add('is-busy');
      try {
        const res = await fetch(form.action || window.location.href, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'text/html' },
          credentials: 'same-origin'
        });
        form.classList.remove('is-busy');
        if (res.ok) {
          showThanks();
        } else {
          showError();
        }
      } catch (_err) {
        form.classList.remove('is-busy');
        showError();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // ===== Account dropdown + register modal =====
  // Wrapped in try/catch so a failure here cannot bubble out and kill the
  // subsequent mega-menu and predictive-search IIFEs in the same bundle.
  (function () {
  try {
    const menu = document.querySelector('[data-account-menu]');
    if (!menu) return;
    const trigger = menu.querySelector('[data-account-trigger]');
    const dropdown = menu.querySelector('[data-account-dropdown]');
    if (!trigger || !dropdown) return;
    const openRegisterBtn = menu.querySelector('[data-open-register]');
    const modal = document.querySelector('[data-register-modal]');

    // Safety: if a previous page lifecycle left body.overflow pinned (e.g. a
    // modal closed mid-animation), restore scrolling. Running on every fresh
    // load means a stuck scroll-lock can never persist across navigations.
    if (modal && modal.hasAttribute('hidden')) {
      document.body.style.overflow = '';
    }

    function closeDropdown() {
      dropdown.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
    function openDropdown() {
      dropdown.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      const input = modal.querySelector('input[type="email"]');
      if (input) setTimeout(() => input.focus(), 160);
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      if (trigger.getAttribute('aria-expanded') === 'true') closeDropdown();
      else openDropdown();
    });

    document.addEventListener('click', (e) => {
      if (!menu.contains(e.target)) closeDropdown();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      closeDropdown();
      if (modal && !modal.hidden) closeModal();
    });

    if (openRegisterBtn) {
      openRegisterBtn.addEventListener('click', () => {
        closeDropdown();
        openModal();
      });
    }
    if (modal) {
      modal.querySelectorAll('[data-register-close]').forEach((el) => {
        el.addEventListener('click', closeModal);
      });
      // Backdrop click = close (already has data-register-close, defensive
      // listener in case that attribute is stripped by a 3p extension).
      const backdrop = modal.querySelector('.register-modal__backdrop');
      if (backdrop) backdrop.addEventListener('click', closeModal);
    }
    // Allow other components (e.g. launch-promo badge) to request the
    // register modal without reaching into our DOM.
    document.addEventListener('gt:open-register', openModal);
  } catch (err) { console.warn('account-menu init failed:', err); }
  })();

  // ===== Products mega menu + mobile drawer =====
  // Wrapped in an IIFE with null-guards so one missing element cannot
  // abort the whole script and silently break unrelated handlers
  // (search, account, etc.) further down the file.
  //
  // I18N is declared INSIDE each IIFE (not at module top) because
  // Shopify concatenates section script blocks on the page
  // into one file — a top-level `const I18N` would collide with the same
  // name in other sections (e.g. category-browser) and cause a SyntaxError
  // that kills the entire bundle.
  (function () {
  try {
  const I18N = window.GT_HEADER_I18N || {};
  // Mirror of sections/category-browser.liquid BROWSER_DATA so the nav mega
  // menu and the landing directory show the same categories/brands. Keep in
  // sync if you edit either. Labels are hardcoded because several categories
  // (parts: conta/kapak/..., new Dorse/Trailer) don't have locale keys yet.
  // Vehicle-type → brands for the navbar mega menu. Parsed from the shared
  // [data-gt-taxonomy] inline JSON (metaobject-driven, same source the category
  // browser uses). DATA_FALLBACK is only used if that snippet is unavailable.
  const TAX = (function () {
    try {
      const node = document.querySelector('[data-gt-taxonomy]');
      return node ? JSON.parse(node.textContent) : null;
    } catch (_e) { return null; }
  })() || { vts: [] };

  const DATA_FALLBACK = {
    agir: { label: "Ağır Vasıta, Otobüs", brands: ["Mercedes", "MAN", "IVECO", "DAF", "SCANIA", "VOLVO", "RENAULT", "American Trucks", "KAMAZ", "IFA W50 Multicar", "Ford", "BMC", "Otokar", "Chrysler"] },
    hafif: { label: "Hafif Ticari, Binek, Japon Grubu", brands: ["BMW", "ISUZU", "KIA", "MITSUBISHI", "NISSAN", "Hyundai", "VOLKSWAGEN", "TOYOTA", "JEEP", "Range Rover"] },
    traktor: { label: "Traktör", brands: ["Massey Ferguson", "John Deere", "Claas", "New Holland", "Fendt", "AGCO", "Fiat", "Ford", "Case IH", "Deutz", "Steyr", "Kubota", "Türk Traktör", "Tümosan", "Kademe", "Erkunt", "Başak", "Hattat", "İhi-shibaura (İşbora)", "Laverda", "Zetor", "Valtra"] },
    isMakinasi: { label: "İş Makinası", brands: ["JCB", "Caterpillar", "Alvano", "Alborz", "Batsan", "Bobcat", "Foton", "Hitachi", "Howo", "Komatsu", "MAZ", "Maxima", "VOLVO", "Hidromek", "Cummins", "Perkins"] },
    dorseTrailer: { label: "Dorse, Trailer", brands: ["Genel Ürünler", "Webasto"] },
    hidrolikDepo: { label: "Hidrolik Direksiyon Deposu", brands: ["Tüm Hidrolik Direksiyon Depoları"] },
    "jeneratör": { label: "Jeneratör", brands: ["Genel Ürünler", "Hidromek", "Cummins", "Perkins"] },
    endustriyel: { label: "Endüstriyel", brands: ["Tüm Endüstriyel"] },
    aluminyumGobek: { label: "Alüminyum Göbek, Fan Kanadı", brands: ["Tüm Alüminyum Göbek / Fan Kanadı"] },
    conta: { label: "Conta, Tapa, Civata, Filtre", brands: ["Tüm Conta Tapa Civata ve Filtre"] },
    kapak: { label: "Kapak", brands: ["Tüm Kapaklar"] },
    sensor: { label: "Sensör", brands: ["Tüm Sensörler"] },
    universal: { label: "Üniversal", brands: [I18N.universal || "Üniversal"] },
    diger: { label: "Diğer", brands: ["Diğer Ürünler"] }
  };

  const DATA = (TAX.vts && TAX.vts.length)
    ? (function () {
        const o = {};
        TAX.vts.forEach(function (vt) { o[vt.key] = { label: vt.label, brands: (vt.brands || []).slice() }; });
        return o;
      })()
    : DATA_FALLBACK;

  const trigger = document.querySelector('[data-nav-toggle]');
  const mega = document.querySelector('[data-mega]');
  const backdrop = document.querySelector('[data-mega-backdrop]');
  if (!trigger || !mega || !backdrop) return;
  const brandList = mega.querySelector('[data-brands]');
  const brandHeading = mega.querySelector('[data-brand-heading]');
  const emptyState = mega.querySelector('[data-empty]');
  if (!brandList || !brandHeading || !emptyState) return;
  const allProductsLabel = I18N.allProducts || "Tüm Ürünler";
  const brandLabelText = I18N.brand || "Marka";
  const backToVehicleTypeText = I18N.backToVehicleType || "Araç tipi";

  // Render the left-column VT list from DATA. Click/hover handlers below use
  // querySelectorAll against the populated DOM, so this must run first.
  // Items are inserted BEFORE the Liquid-rendered "Tüm Ürünler" anchor so the
  // existing flex space-between layout pins that entry to the bottom.
  const vtListEl = mega.querySelector('[data-mega-vts]');
  const allAnchor = vtListEl && vtListEl.querySelector('[data-mega-all-wrap]');
  if (vtListEl && allAnchor) {
    Object.entries(DATA).forEach(([key, vt]) => {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.className = 'mega__item';
      btn.dataset.next = key;
      btn.innerHTML = `<span class="mega__dot"></span>${vt.label}`;
      li.appendChild(btn);
      vtListEl.insertBefore(li, allAnchor);
    });
  }

  // Custom always-visible scrollbar — defined inline (not via snippet) so
  // there's no bundling-order risk: the IIFE runs in-band before we use it.
  // Idempotent across pages: redefines window.gtAttachCustomScrollbar only if
  // not already present.
  (function () {
    if (window.gtAttachCustomScrollbar) return;
    window.gtAttachCustomScrollbar = function (scrollEl) {
      if (!scrollEl) return function () {};
      if (scrollEl.dataset.cscrollAttached === '1') return scrollEl.__cscrollRefresh || function () {};
      scrollEl.dataset.cscrollAttached = '1';
      scrollEl.classList.add('gt-cscroll-host');
      var p = scrollEl.parentNode;
      if (getComputedStyle(p).position === 'static') p.style.position = 'relative';
      var bar = document.createElement('div');
      bar.className = 'gt-cscroll';
      var thumb = document.createElement('div');
      thumb.className = 'gt-cscroll__thumb';
      bar.appendChild(thumb);
      p.appendChild(bar);
      function position() {
        var c = scrollEl.getBoundingClientRect();
        var pr = p.getBoundingClientRect();
        if (c.width === 0 || c.height === 0) { bar.style.display = 'none'; return false; }
        bar.style.display = 'block';
        bar.style.top = (c.top - pr.top + 6) + 'px';
        bar.style.left = (c.right - pr.left - 14) + 'px';
        bar.style.height = (c.height - 12) + 'px';
        return true;
      }
      function update() {
        if (!position()) return;
        var ch = scrollEl.scrollHeight, vh = scrollEl.clientHeight;
        if (ch <= vh + 1) { bar.dataset.empty = 'true'; return; }
        bar.dataset.empty = 'false';
        var th = bar.clientHeight, ratio = vh / ch;
        var thumbH = Math.max(28, th * ratio);
        var maxScroll = ch - vh, maxThumb = th - thumbH;
        var t = maxScroll > 0 ? (scrollEl.scrollTop / maxScroll) * maxThumb : 0;
        thumb.style.height = thumbH + 'px';
        thumb.style.transform = 'translateY(' + t + 'px)';
      }
      function refresh() { requestAnimationFrame(update); }
      scrollEl.__cscrollRefresh = refresh;
      scrollEl.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', refresh);
      if (typeof ResizeObserver !== 'undefined') {
        try { new ResizeObserver(refresh).observe(scrollEl); } catch (_) {}
      }
      var dragStart = null;
      thumb.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        try { thumb.setPointerCapture(e.pointerId); } catch (_) {}
        thumb.classList.add('is-dragging');
        dragStart = { y: e.clientY, scrollTop: scrollEl.scrollTop };
      });
      thumb.addEventListener('pointermove', function (e) {
        if (!dragStart) return;
        var th = bar.clientHeight, thumbH = thumb.clientHeight, maxThumb = th - thumbH;
        if (maxThumb <= 0) return;
        var dy = e.clientY - dragStart.y;
        var maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
        scrollEl.scrollTop = dragStart.scrollTop + (dy / maxThumb) * maxScroll;
      });
      function endDrag() { dragStart = null; thumb.classList.remove('is-dragging'); }
      thumb.addEventListener('pointerup', endDrag);
      thumb.addEventListener('pointercancel', endDrag);
      thumb.addEventListener('lostpointercapture', endDrag);
      bar.addEventListener('mousedown', function (e) {
        if (e.target === thumb) return;
        var rect = bar.getBoundingClientRect();
        var clickY = e.clientY - rect.top;
        var th = bar.clientHeight, thumbH = thumb.clientHeight, maxThumb = th - thumbH;
        var maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
        if (maxThumb <= 0) return;
        var target = Math.max(0, Math.min(maxThumb, clickY - thumbH / 2));
        scrollEl.scrollTo({ top: (target / maxThumb) * maxScroll, behavior: 'smooth' });
      });
      requestAnimationFrame(update);
      setTimeout(update, 120);
      return refresh;
    };
  })();

  // Attach to the VT column (mega menu starts hidden → refresh on open).
  const vtCol = mega.querySelector('.mega__col[data-level="1"]');
  let vtScrollRefresh = null;
  if (vtCol) vtScrollRefresh = window.gtAttachCustomScrollbar(vtCol);

  function resetRight() {
    brandList.innerHTML = '';
    brandList.hidden = true;
    emptyState.hidden = false;
    brandHeading.textContent = brandLabelText;
  }

  function closeAll() {
    mega.hidden = true;
    backdrop.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    resetRight();
    mega.querySelectorAll('.is-active').forEach(el => el.classList.remove('is-active'));
  }

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    const open = trigger.getAttribute('aria-expanded') === 'true';
    if (open) closeAll();
    else {
      mega.hidden = false;
      backdrop.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      resetRight();
      // The VT column was display:none when the custom scrollbar was attached
      // (getBoundingClientRect was 0×0). Now that it's visible, re-measure.
      if (vtScrollRefresh) vtScrollRefresh();
    }
  });

  backdrop.addEventListener('click', closeAll);

  // Mobile drawer
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const mobileSearchTrigger = document.querySelector('[data-mobile-search-trigger]');
  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', () => {
      const open = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', String(!open));
      mobileDrawer.hidden = open;
    });
    if (mobileSearchTrigger) {
      mobileSearchTrigger.addEventListener('click', () => {
        mobileToggle.setAttribute('aria-expanded', 'true');
        mobileDrawer.hidden = false;
        const drawerInput = mobileDrawer.querySelector('[data-nav-search-input]');
        if (drawerInput) {
          // Defer focus so iOS Safari opens the on-screen keyboard reliably
          // after the drawer transitions in.
          setTimeout(() => drawerInput.focus(), 50);
        }
      });
    }
  }

  // Mobile products drilldown (same flow as desktop mega)
  const mobileProductsBtn = document.querySelector('[data-mobile-products]');
  const mobileProductsContent = document.querySelector('[data-mobile-products-content]');
  const mobileVts = document.querySelector('[data-mobile-vts]');
  const mobileBrands = document.querySelector('[data-mobile-brands]');

  if (mobileProductsBtn) {
    mobileProductsBtn.addEventListener('click', () => {
      const open = mobileProductsBtn.getAttribute('aria-expanded') === 'true';
      mobileProductsBtn.setAttribute('aria-expanded', String(!open));
      mobileProductsContent.hidden = open;
      if (!open) renderMobileVts();
    });
  }

  function renderMobileVts() {
    mobileVts.innerHTML = '';
    mobileBrands.hidden = true;
    mobileVts.hidden = false;
    Object.entries(DATA).forEach(([key, vt]) => {
      const btn = document.createElement('button');
      btn.className = 'mobile-products__item';
      btn.innerHTML = `${vt.label} <span style="margin-left:auto;opacity:0.4">›</span>`;
      btn.addEventListener('click', () => renderMobileBrands(key, vt));
      mobileVts.appendChild(btn);
    });
    // "Tüm Ürünler" — no brand drill-down, selects all directly
    const allBtn = document.createElement('button');
    allBtn.className = 'mobile-products__item mobile-products__item--all';
    allBtn.textContent = allProductsLabel;
    allBtn.addEventListener('click', () => {
      mobileDrawer.hidden = true;
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileProductsBtn.setAttribute('aria-expanded', 'false');
      mobileProductsContent.hidden = true;
      if (document.getElementById('category-browser')) {
        document.dispatchEvent(new CustomEvent('garantiteknik:brand-selected', {
          detail: { vtKey: null, brand: null, label: allProductsLabel }
        }));
      } else {
        window.location.href = '/?all=1#category-browser';
      }
    });
    mobileVts.appendChild(allBtn);
  }

  function renderMobileBrands(vtKey, vt) {
    mobileBrands.innerHTML = '';
    mobileVts.hidden = true;
    mobileBrands.hidden = false;

    const back = document.createElement('button');
    back.className = 'mobile-products__back';
    back.textContent = backToVehicleTypeText;
    back.addEventListener('click', renderMobileVts);
    mobileBrands.appendChild(back);

    vt.brands.forEach(b => {
      const btn = document.createElement('button');
      btn.className = 'mobile-products__item';
      btn.innerHTML = `<span class="mega__dot"></span>${b}`;
      btn.addEventListener('click', () => {
        // close drawer
        mobileDrawer.hidden = true;
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileProductsBtn.setAttribute('aria-expanded', 'false');
        mobileProductsContent.hidden = true;
        if (document.getElementById('category-browser')) {
          document.dispatchEvent(new CustomEvent('garantiteknik:brand-selected', {
            detail: { vtKey: vtKey, brand: b, label: `${vt.label} › ${b}` }
          }));
        } else {
          window.location.href = '/?vt=' + encodeURIComponent(vtKey) + '&brand=' + encodeURIComponent(b) + '#category-browser';
        }
      });
      mobileBrands.appendChild(btn);
    });
  }

  document.addEventListener('click', (e) => {
    if (!mega.contains(e.target) && !trigger.contains(e.target) && !backdrop.contains(e.target)) closeAll();
  });

  mega.querySelectorAll('[data-level="1"] .mega__item').forEach(btn => {
    if (btn.hasAttribute('data-all')) {
      btn.addEventListener('mouseenter', () => {
        mega.querySelectorAll('[data-level="1"] .mega__item').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        resetRight();
        brandHeading.textContent = allProductsLabel;
      });
      btn.addEventListener('click', () => {
        closeAll();
        if (document.getElementById('category-browser')) {
          document.dispatchEvent(new CustomEvent('garantiteknik:brand-selected', {
            detail: { vtKey: null, brand: null, label: allProductsLabel }
          }));
        } else {
          window.location.href = '/?all=1#category-browser';
        }
      });
    } else {
      btn.addEventListener('mouseenter', () => showBrands(btn));
      btn.addEventListener('click', () => showBrands(btn));
    }
  });

  function showBrands(btn) {
    mega.querySelectorAll('[data-level="1"] .mega__item').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    const key = btn.dataset.next;
    const vt = DATA[key];
    if (!vt) return;
    brandHeading.textContent = vt.label + " › " + brandLabelText;
    brandList.innerHTML = '';
    vt.brands.forEach(b => {
      const li = document.createElement('li');
      const item = document.createElement('button');
      item.className = 'mega__item';
      item.innerHTML = `<span class="mega__dot"></span>${b}`;
      item.addEventListener('click', () => {
        closeAll();
        if (document.getElementById('category-browser')) {
          document.dispatchEvent(new CustomEvent('garantiteknik:brand-selected', {
            detail: { vtKey: key, brand: b, label: `${vt.label} › ${b}` }
          }));
        } else {
          window.location.href = '/?vt=' + encodeURIComponent(key) + '&brand=' + encodeURIComponent(b) + '#category-browser';
        }
      });
      li.appendChild(item);
      brandList.appendChild(li);
    });
    emptyState.hidden = true;
    brandList.hidden = false;
  }
  } catch (err) { console.warn('mega-menu init failed:', err); }
  })();

  // ===== Navbar predictive search =====
  (function () {
  try {
    const I18N = window.GT_HEADER_I18N || {};
    const wraps = document.querySelectorAll('[data-nav-search]');
    if (!wraps.length) return;

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }

    // Client-side OEM/handle index (reads the JSON already inlined by the
    // category-browser). Matches parts by OEM regardless of spacing or
    // punctuation — `A0004663802` finds `A000 466 3802`.
    function normToken(s) {
      // Strip EVERYTHING except letters (incl. Turkish) and digits so OEM
      // matching is punctuation-agnostic: "123/05911", "430.0617*", "20°-50°",
      // "(110113)", "A000 466 3802" all collapse to clean alphanumerics. Both
      // the query and the stored value pass through this, so matching stays
      // consistent. \p{L}/\p{N} keep ü/ı/ş/ö for Turkish text search.
      return String(s == null ? '' : s).toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '');
    }
    function stripHtml(s) {
      return String(s == null ? '' : s).replace(/<[^>]*>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ');
    }

    let LOCAL_INDEX = [];
    let LOCAL_SEEN = new Set();
    let LOCAL_SEEDED = false;

    // Seed the index from the products JSON. The data used to be inlined into
    // category-browser, but it grew past Shopify's 256 KB per-template limit,
    // so it now lives at assets/products-data.json and category-browser
    // exposes the loaded data + a Promise on `window`. We await that promise
    // when present, or fetch the asset URL directly on non-home pages where
    // the category-browser section isn't rendered.
    async function seedLocalIndex() {
      if (LOCAL_SEEDED) return;
      LOCAL_SEEDED = true;
      try {
        let data = window.GT_PRODUCTS_DATA;
        if (!data && window.GT_PRODUCTS_DATA_PROMISE) {
          data = await window.GT_PRODUCTS_DATA_PROMISE;
        }
        if (!data) {
          // No category-browser on this page — fetch directly. The header
          // emits the asset URL via a meta tag rendered by Liquid below.
          const meta = document.querySelector('meta[name="gt-products-url"]');
          const url = meta && meta.getAttribute('content');
          if (!url) return;
          const res = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!res.ok) return;
          data = await res.json();
          window.GT_PRODUCTS_DATA = data;
        }
        for (const vt in data) {
          for (const br in data[vt]) {
            for (const parent in data[vt][br]) {
              for (const sub in data[vt][br][parent]) {
                const list = data[vt][br][parent][sub] || [];
                for (const p of list) {
                  if (!p || !p.handle || LOCAL_SEEN.has(p.handle)) continue;
                  LOCAL_SEEN.add(p.handle);
                  LOCAL_INDEX.push({
                    handle: p.handle,
                    title: p.title,
                    image: p.image,
                    vendor: br,
                    oem: p.oem || '',
                    ref: p.ref || '',
                    hay: normToken([p.title, p.oem, p.ref, p.handle, br].join(' '))
                  });
                }
              }
            }
          }
        }
      } catch (err) { console.warn('local search seed failed', err); }
    }

    // Extend the index with the live Shopify product catalog — pulls
    // body_html (descriptions) so OEM codes stored inside the product
    // description are also matched whitespace-insensitively. Cached in
    // sessionStorage so we pay the fetch cost once per tab.
    let PRODUCTS_JSON_LOADED = false;
    let PRODUCTS_JSON_PROMISE = null;
    async function extendWithProductsJson() {
      if (PRODUCTS_JSON_LOADED) return;
      if (PRODUCTS_JSON_PROMISE) return PRODUCTS_JSON_PROMISE;
      PRODUCTS_JSON_PROMISE = (async () => {
        try {
          let products = null;
          const cached = sessionStorage.getItem('gt-products-json');
          if (cached) {
            try { products = JSON.parse(cached); } catch (_e) { products = null; }
          }
          if (!products) {
            products = [];
            for (let page = 1; page <= 4; page++) { // up to 1000 products
              const res = await fetch('/products.json?limit=250&page=' + page, {
                headers: { Accept: 'application/json' }
              });
              if (!res.ok) break;
              const data = await res.json();
              const list = (data && data.products) || [];
              if (!list.length) break;
              for (const p of list) {
                products.push({
                  handle: p.handle,
                  title: p.title,
                  vendor: p.vendor,
                  product_type: p.product_type,
                  tags: Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || ''),
                  body_html: p.body_html || '',
                  image: (p.images && p.images[0] && p.images[0].src) || '',
                  sku: (p.variants && p.variants[0] && p.variants[0].sku) || ''
                });
              }
              if (list.length < 250) break;
            }
            try { sessionStorage.setItem('gt-products-json', JSON.stringify(products)); } catch (_e) {}
          }
          for (const p of products) {
            if (!p || !p.handle) continue;
            const body = stripHtml(p.body_html);
            const hayNew = normToken([p.title, p.vendor, p.product_type, p.tags, p.sku, body, p.handle].join(' '));
            // Pull OEM from `oem:` tag if present (mirrors pcard.liquid heuristic).
            // Falls back to the products-data.json entry that may already have it.
            let oemFromTag = '';
            const tagStr = p.tags || '';
            const oemMatch = tagStr.match(/(?:^|\s)oem:([^\s,]+(?:[^,]*[^\s,])?)/i);
            if (oemMatch) oemFromTag = oemMatch[1].trim();
            if (LOCAL_SEEN.has(p.handle)) {
              const existing = LOCAL_INDEX.find((x) => x.handle === p.handle);
              if (existing) {
                existing.hay = existing.hay + hayNew;
                if (!existing.oem && oemFromTag) existing.oem = oemFromTag;
                if (!existing.ref && p.sku) existing.ref = p.sku;
              }
            } else {
              LOCAL_SEEN.add(p.handle);
              LOCAL_INDEX.push({
                handle: p.handle,
                title: p.title,
                image: p.image,
                vendor: p.vendor,
                oem: oemFromTag,
                ref: p.sku || '',
                hay: hayNew
              });
            }
          }
          PRODUCTS_JSON_LOADED = true;
        } catch (err) { console.warn('products.json fetch failed', err); }
      })();
      return PRODUCTS_JSON_PROMISE;
    }

    // Kick off the seed early so the first user search has a populated index.
    seedLocalIndex();

    // A query "looks like a part code" when it contains a digit and is long
    // enough to be an OEM / GT reference (after stripping spaces/punctuation).
    // For these we search ONLY the OEM/ref/title fields and rank exact hits
    // first — so typing a full OEM no longer drags in unrelated products whose
    // description merely happens to contain the digits. Plain-text queries
    // ("radyatör kapağı") keep the broader behaviour.
    function looksLikeCode(n) {
      return /[0-9]/.test(n) && n.length >= 4;
    }

    // Split a raw OEM/ref field into individual codes. A single OEM may contain
    // internal spaces ("A000 466 3802") AND an internal slash (JCB codes like
    // "123/05911", variant codes like "074121302A/B/C") which normToken later
    // collapses — so we split ONLY on the real multi-OEM delimiters (| , ;),
    // never on whitespace or "/". (Multi-OEM fields in this catalog use "|".)
    function splitCodes(s) {
      return String(s == null ? '' : s)
        .split(/[|,;•\n]+/)
        .map((x) => x.trim())
        .filter(Boolean);
    }

    // Relevance tiers (higher = better). Returned { score, tier } or null.
    //   tier 3 = exact OEM or exact GT-ref  → the "tıpatıp" hero match
    //   tier 2 = OEM/ref prefix or substring
    //   tier 1 = title / vendor match
    //   tier 0 = weak (matched only inside description/tags/handle haystack)
    function scoreEntry(p, n) {
      const oemCodes = splitCodes(p.oem).map(normToken).filter(Boolean);
      const oemAll = normToken(p.oem);

      // GT reference candidates: the ref/SKU field AND the "... | GT-XXX"
      // suffix baked into the title. Each kept both with and without the "gt"
      // prefix so "GT-Y20.017", "Y20.017", "y20 017" all resolve to the same
      // product. (normToken strips the dash/dot/space.)
      const refSet = new Set();
      const addRef = (raw) => {
        const r = normToken(raw);
        if (!r) return;
        refSet.add(r);
        refSet.add(r.replace(/^gt/, ''));
      };
      addRef(p.ref);
      const titleParts = String(p.title || '').split(' | GT-');
      if (titleParts.length > 1) addRef('gt' + titleParts[1]);

      // tier 3 — exact OEM or exact GT-ref
      for (const c of oemCodes) if (c === n) return { score: 100, tier: 3 };
      if (refSet.has(n) || refSet.has('gt' + n)) return { score: 98, tier: 3 };

      // tier 2 — OEM/ref prefix or contains
      for (const c of oemCodes) {
        if (c.startsWith(n) || n.startsWith(c)) return { score: 82, tier: 2 };
      }
      if (oemAll && oemAll.indexOf(n) !== -1) return { score: 74, tier: 2 };
      for (const r of refSet) {
        if (r && (r.startsWith(n) || r.indexOf(n) !== -1)) return { score: 70, tier: 2 };
      }

      // tier 1 — title / vendor
      if (normToken(p.title).indexOf(n) !== -1) return { score: 45, tier: 1 };
      if (normToken(p.vendor).indexOf(n) !== -1) return { score: 38, tier: 1 };

      // tier 0 — weak (description / tags / handle only)
      if (p.hay && p.hay.indexOf(n) !== -1) return { score: 15, tier: 0 };
      return null;
    }

    function localSearch(q, limit, codeLike) {
      const n = normToken(q);
      if (n.length < 2) return [];
      seedLocalIndex();
      const scored = [];
      for (const p of LOCAL_INDEX) {
        const s = scoreEntry(p, n);
        if (!s) continue;
        // For code-like queries, drop weak description-only hits — those are
        // the "alakasız ürünler" the customer complained about.
        if (codeLike && s.tier === 0) continue;
        scored.push({ p: p, score: s.score, tier: s.tier });
      }
      // Rank: score desc, then shorter title first (more specific product).
      scored.sort((a, b) =>
        b.score - a.score ||
        String(a.p.title || '').length - String(b.p.title || '').length
      );
      const out = [];
      for (const e of scored) {
        const p = e.p;
        out.push({
          url: '/products/' + p.handle,
          title: p.title,
          vendor: p.vendor,
          featured_image: p.image ? { url: p.image } : null,
          handle: p.handle,
          oem: p.oem,
          ref: p.ref,
          _tier: e.tier
        });
        if (out.length >= limit) break;
      }
      return out;
    }

    async function shopifySearch(q) {
      // Shopify predictive search — https://shopify.dev/docs/api/ajax/reference/predictive-search
      // Fields key requires `variants.sku` / `variants.barcode` (not `sku`)
      // and the per-type limit must be <=10 or the endpoint 422s.
      const params = new URLSearchParams();
      params.set('q', q);
      params.append('resources[type]', 'product');
      params.append('resources[limit]', '10');
      params.append('resources[limit_scope]', 'each');
      params.append('resources[options][unavailable_products]', 'last');
      params.append(
        'resources[options][fields]',
        'title,vendor,product_type,tag,variants.sku,variants.barcode,body'
      );
      const res = await fetch('/search/suggest.json?' + params.toString(), {
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) throw new Error('status ' + res.status);
      const data = await res.json();
      return (data && data.resources && data.resources.results && data.resources.results.products) || [];
    }

    // Bind handlers per search instance (desktop navbar + mobile drawer).
    // The index/seed/fetch helpers above are shared in the closure so both
    // wraps see the same LOCAL_INDEX without duplicate fetches.
    wraps.forEach((wrap) => {
      const input = wrap.querySelector('[data-nav-search-input]');
      const results = wrap.querySelector('[data-nav-search-results]');
      if (!input || !results) return;

      let timer;
      let activeIdx = -1;
      let lastQuery = '';

      function close() {
        results.hidden = true;
        activeIdx = -1;
      }

      function renderState(html) {
        results.innerHTML = html;
        results.hidden = false;
      }

      // Build one result row. `hero` renders the exact match larger with a
      // "Tam eşleşme" badge.
      function renderCard(p, hero) {
        const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        const imgUrl = img
          ? img + (img.indexOf('?') === -1 ? '?width=120' : '&width=120')
          : '';
        const imgTag = imgUrl
          ? '<img class="search__result-img" src="' + esc(imgUrl) + '" alt="' + esc((p.title || '').split(' | GT-')[0]) + '" loading="lazy">'
          : '<div class="search__result-img"></div>';
        // Title with GT- ref preserved as a faded chip. Shopify predictive
        // titles often already carry " | GT-XXX"; if not, fall back to the
        // index ref we added from products-data.json or product SKU.
        const titleStr = p.title || '';
        const parts = titleStr.split(' | GT-');
        const mainTitle = parts[0];
        let ref = parts.length > 1 ? 'GT-' + parts[1] : '';
        if (!ref && p.ref) ref = String(p.ref).startsWith('GT-') ? p.ref : 'GT-' + p.ref;
        // OEM: if we have one indexed for this handle, show the first code.
        let oem = '';
        if (p.oem) {
          oem = String(p.oem).split('|')[0].split(',')[0].trim();
        }
        const vendor = p.vendor || p.type || '';
        // Meta line: "Vendor · OEM: XYZ" — drops parts that are empty so
        // we don't leave a dangling separator.
        const metaParts = [];
        if (vendor) metaParts.push(esc(vendor));
        if (oem) metaParts.push('OEM: ' + esc(oem));
        const metaHtml = metaParts.length
          ? '<div class="search__result-meta">' + metaParts.join(' · ') + '</div>'
          : '';
        const refHtml = ref ? ' <span class="search__result-ref">' + esc(ref) + '</span>' : '';
        const badgeHtml = hero
          ? '<div class="search__result-badge">' + esc(I18N.exactMatch || 'Tam eslesme') + '</div>'
          : '';
        const cls = hero ? 'search__result search__result--hero' : 'search__result';
        return '<a class="' + cls + '" href="' + esc(p.url) + '">'
          + imgTag
          + '<div class="search__result-info">'
          +   badgeHtml
          +   '<div class="search__result-title">' + esc(mainTitle) + refHtml + '</div>'
          +   metaHtml
          + '</div></a>';
      }

      function renderResults(products, q, codeLike) {
        activeIdx = -1;
        // The "see all results" footer links to the fuzzy /search page. For
        // OEM/ref (code-like) queries the ranked dropdown IS the authoritative
        // answer — exact match on top, near matches below — so we drop the
        // footer there. Plain-text queries keep it for breadth.
        const footerText = I18N.seeAllResults || 'Tum sonuclari gor';
        const footer = codeLike
          ? ''
          : '<a class="search__footer" href="/search?q=' + encodeURIComponent(q) + '">' + esc(footerText) + '</a>';
        if (!products.length) {
          const queryToken = '{' + '{ query }' + '}';
          const template = I18N.noResultsFor || '"' + queryToken + '" icin sonuc bulunamadi.';
          const msg = String(template).replace(queryToken, esc(q));
          renderState('<div class="search__empty">' + msg + '</div>' + footer);
          return;
        }
        let html = '';
        let rest = products;
        // Promote a single exact (tıpatıp) match to a prominent hero card at
        // the top, with the remaining matches grouped under "Diğer sonuçlar".
        if (products[0] && products[0]._tier === 3) {
          html += renderCard(products[0], true);
          rest = products.slice(1);
          if (rest.length) {
            html += '<div class="search__section-label">' + esc(I18N.otherResults || 'Diger sonuclar') + '</div>';
          }
        }
        rest.forEach((p) => { html += renderCard(p, false); });
        html += footer;
        renderState(html);
      }

      function renderRanked(shopifyResults, localResults, q, codeLike) {
        const seen = new Set();
        const merged = [];
        // LOCAL FIRST, already ranked (exact OEM/ref → title → weak). The local
        // index is our complete, always-current catalog so newly-added products
        // are findable immediately and the ordering reflects true relevance.
        for (const p of localResults) {
          if (!p || !p.handle || seen.has(p.handle)) continue;
          seen.add(p.handle);
          merged.push(p);
        }
        // Shopify predictive search is fuzzy and was the source of the
        // "unrelated products" complaint. For code-like (OEM/ref) queries we
        // skip it entirely. For text queries we let it SUPPLEMENT, but only
        // when the product title actually contains the query — fuzzy/typo hits
        // that match nothing relevant are dropped.
        if (!codeLike) {
          const nq = normToken(q);
          for (const p of shopifyResults) {
            if (!p || !p.handle || seen.has(p.handle)) continue;
            if (normToken(p.title).indexOf(nq) === -1) continue;
            seen.add(p.handle);
            // Predictive endpoint omits OEM/SKU — enrich from the local index.
            const local = LOCAL_INDEX.find((x) => x.handle === p.handle);
            if (local) {
              if (!p.oem) p.oem = local.oem;
              if (!p.ref) p.ref = local.ref;
            }
            p._tier = 1;
            merged.push(p);
          }
        }
        renderResults(merged.slice(0, 10), q, codeLike);
      }

      async function runSearch(q) {
        lastQuery = q;
        const codeLike = looksLikeCode(normToken(q));

        // Kick off a one-time fetch of /products.json to pull each product's
        // body_html (description) into the local index. First hit is slow-ish;
        // subsequent keystrokes reuse the cached index instantly.
        const extendPromise = extendWithProductsJson();
        // Code queries rely on the comprehensive local index only (no fuzzy
        // Shopify noise); text queries still hit predictive search for breadth.
        const shopifyPromise = codeLike
          ? Promise.resolve([])
          : shopifySearch(q).catch((err) => {
              console.warn('predictive search failed', err);
              return [];
            });

        // First pass — immediately show what we can from the already-seeded
        // local index so there is no blank dropdown while products.json loads.
        let local = localSearch(q, 12, codeLike);
        let shopifyResults = await shopifyPromise;
        if (lastQuery !== q) return;
        renderRanked(shopifyResults, local, q, codeLike);

        // Second pass — once product descriptions are indexed, re-run the
        // local search so OEM codes that live inside product descriptions
        // (e.g. "A000 466 3802" found from a query like "A0004663802") appear.
        await extendPromise;
        if (lastQuery !== q) return;
        local = localSearch(q, 12, codeLike);
        renderRanked(shopifyResults, local, q, codeLike);
      }

      input.addEventListener('input', () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if (q.length < 2) {
          close();
          return;
        }
        renderState('<div class="search__loading">' + esc(I18N.searching || 'Araniyor...') + '</div>');
        timer = setTimeout(() => runSearch(q), 180);
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false;
      });

      input.addEventListener('keydown', (e) => {
        const items = results.querySelectorAll('.search__result');
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (!items.length) return;
          activeIdx = Math.min(activeIdx + 1, items.length - 1);
          items.forEach((el, i) => el.classList.toggle('is-active', i === activeIdx));
          items[activeIdx].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (!items.length) return;
          activeIdx = Math.max(activeIdx - 1, 0);
          items.forEach((el, i) => el.classList.toggle('is-active', i === activeIdx));
          items[activeIdx].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter') {
          e.preventDefault();
          // Enter navigates ONLY when there is an EXACT match (the "Tam eşleşme"
          // hero row). With no exact match, Enter does nothing — the user must
          // pick a row from the list. An arrow-key selection is an explicit
          // choice and is always honored.
          if (activeIdx >= 0 && items[activeIdx]) {
            window.location.href = items[activeIdx].href;
          } else if (items.length && items[0] && items[0].classList.contains('search__result--hero')) {
            window.location.href = items[0].href;
          } else if (!items.length) {
            // Fast Enter before the dropdown rendered → only on an exact match.
            const q = input.value.trim();
            if (q.length >= 2) {
              const top = localSearch(q, 1, looksLikeCode(normToken(q)))[0];
              if (top && top._tier === 3 && top.url) window.location.href = top.url;
            }
          }
        } else if (e.key === 'Escape') {
          close();
          input.blur();
        }
      });

      document.addEventListener('click', (e) => {
        if (!wrap.contains(e.target)) close();
      });
    });
  } catch (err) { console.warn('nav-search init failed:', err); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-promo"] && !Shopify.designMode) return;
  try {
    
  // 1) On success, Shopify reloads with `?customer_posted=true`. Strip that
  //    from the URL so a later refresh doesn't keep the success banner up
  //    forever.
  // 2) Keep the input truly empty on mount — some browsers auto-restore the
  //    previously typed email after the successful POST.
  (function () {
    const url = new URL(window.location.href);
    if (url.searchParams.has('customer_posted')) {
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('form_type');
      window.history.replaceState({}, document.title, url.pathname + (url.search ? url.search : '') + url.hash);
    }

    const slot = document.querySelector('[data-nl-slot]');
    if (!slot) return;
    const input = slot.querySelector('input[type="email"]');
    if (input) {
      // Delay so any browser-restored value is overwritten after it applies.
      setTimeout(() => { input.value = ''; }, 0);
    }

    // Scroll the success banner into view once after posting so the user
    // actually sees the confirmation.
    if (slot.querySelector('.nl-promo__success') && sessionStorage.getItem('nl-scrolled') !== '1') {
      sessionStorage.setItem('nl-scrolled', '1');
      slot.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  // Contact form bot guard: honeypot + min-elapsed-time check. Silently
  // aborts submission for obvious bots (filled honeypot, or form submitted
  // within 2s of page load). Real users won't trigger either path.
  (function () {
    var form = document.getElementById('ContactForm');
    if (!form) return;

    var loadedAt = Date.now();
    var MIN_ELAPSED_MS = 2000;

    form.addEventListener('submit', function (event) {
      var honey = form.querySelector('input[name="website"]');
      var honeyFilled = honey && honey.value.trim() !== '';
      var elapsed = Date.now() - loadedAt;
      var tooFast = elapsed < MIN_ELAPSED_MS;

      if (honeyFilled || tooFast) {
        event.preventDefault();
        event.stopPropagation();
        // Don't show an error to the user — bots get a silent black hole,
        // and on the rare false positive (someone autofilled "website")
        // the page just appears to do nothing on submit, which the user
        // will retry.
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Wrapped in an IIFE + try/catch so this file's top-level identifiers
  // (thumbs, mainImg, variantSel, pdpCart) don't leak into the bundle scope
  // shared with other sections, and a runtime crash here (on pages where
  // the PDP markup isn't present) can't cascade into unrelated handlers in
  // header.liquid.
  (function () {
    try {
      // Back button: when the user landed on this PDP from another page on
      // the same site, pressing the button jumps to that page via
      // history.back(). On direct visits / new tabs we fall through to the
      // anchor's href (All Products collection) for a sensible fallback.
      document.querySelectorAll('[data-pdp-back]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          var ref = document.referrer || '';
          var sameOrigin = false;
          if (ref) {
            try { sameOrigin = new URL(ref).origin === window.location.origin; } catch (_e) {}
          }
          if (sameOrigin && window.history.length > 1) {
            e.preventDefault();
            window.history.back();
          }
        });
      });

      // Breadcrumb enrichment — append VT, meta-short, meta-full and sub
      // crumbs by looking up the product's placement in products-data.json.
      // No brand crumb (multi-brand products would be ambiguous). Sub label
      // comes from product.type (Shopify field) so it matches what merchants
      // already see in admin. Silently degrades to the base 3-crumb chain
      // when the product isn't in products-data.json yet (DRAFT, just
      // created, etc.).
      (function enrichCrumbs() {
        var nav = document.querySelector('[data-pdp-crumbs]');
        if (!nav) return;
        var handle = nav.dataset.productHandle;
        if (!handle) return;
        var productType = (nav.dataset.productType || '').trim();

        var VT_LABELS = {
          agir: 'Ağır Vasıta / Otobüs',
          hafif: 'Hafif Ticari / Binek / Japon Grubu',
          'jeneratör': 'Jeneratör',
          traktor: 'Traktör',
          isMakinasi: 'İş Makinası',
          dorseTrailer: 'Dorse / Trailer',
          endustriyel: 'Endüstriyel',
          aluminyumGobek: 'Alüminyum Göbek / Fan Kanadı',
          conta: 'Conta, Tapa, Civata ve Filtre',
          kapak: 'Kapak',
          sensor: 'Sensör',
          hidrolikDepo: 'Hidrolik Direksiyon Deposu',
          diger: 'Diğer',
          universal: 'Universal'
        };
        var META_LABELS = {
          motor_sogutma:        { short: 'Motor Soğutma',        full: 'Motor Soğutma Sistemi' },
          motor_yaglama:        { short: 'Motor Yağlama',        full: 'Motor Yağlama Sistemi' },
          cam_silecek:          { short: 'Cam & Silecek',        full: 'Cam Yıkama ve Silecek Sistemi' },
          hidrolik_direksiyon:  { short: 'Hidrolik Direksiyon',  full: 'Hidrolik Direksiyon Sistemi' },
          karoseri:             { short: 'Dış Gövde',            full: 'Dış Gövde ve Karoseri Sistemi' },
          yakit:                { short: 'Yakıt',                full: 'Yakıt Sistemi' },
          egzoz_scr:            { short: 'Egzoz / SCR',          full: 'Egzoz Emisyon Sistemi (SCR)' },
          karter_pcv:           { short: 'Karter Havalandırma',  full: 'Karter Havalandırma Sistemi' },
          elektrik:             { short: 'Elektrik',             full: 'Elektrik Sistemi' },
          hava_emis:            { short: 'Hava Emiş',            full: 'Hava Emiş Sistemi' },
          park_sabitleme:       { short: 'Park Sabitleme',       full: 'Park Sabitleme Sistemi' }
        };

        function getProductsData() {
          if (window.GT_PRODUCTS_DATA) return Promise.resolve(window.GT_PRODUCTS_DATA);
          if (window.GT_PRODUCTS_DATA_PROMISE) return window.GT_PRODUCTS_DATA_PROMISE;
          var meta = document.querySelector('meta[name="gt-products-url"]');
          var url = meta && meta.getAttribute('content');
          if (!url) return Promise.reject(new Error('no products-data url'));
          window.GT_PRODUCTS_DATA_PROMISE = fetch(url, { credentials: 'omit' })
            .then(function (r) { return r.json(); })
            .then(function (d) { window.GT_PRODUCTS_DATA = d; return d; });
          return window.GT_PRODUCTS_DATA_PROMISE;
        }

        function findPlacement(data, h) {
          for (var vt in data) {
            for (var br in data[vt]) {
              for (var par in data[vt][br]) {
                for (var sub in data[vt][br][par]) {
                  var list = data[vt][br][par][sub] || [];
                  for (var i = 0; i < list.length; i++) {
                    if (list[i] && list[i].handle === h) return { vt: vt, meta: par, sub: sub };
                  }
                }
              }
            }
          }
          return null;
        }

        function makeSep() {
          var s = document.createElement('span');
          s.className = 'pdp__crumb-sep';
          s.setAttribute('aria-hidden', 'true');
          s.textContent = '›';
          return s;
        }
        function makeSpan(text) {
          var s = document.createElement('span');
          s.className = 'pdp__crumb';
          s.textContent = text;
          return s;
        }
        function makeAnchor(text, href) {
          var a = document.createElement('a');
          a.href = href;
          a.textContent = text;
          return a;
        }

        function render(placement) {
          if (!placement) return;
          var vtLabel = VT_LABELS[placement.vt];
          var metaPair = META_LABELS[placement.meta];
          var metaShort = metaPair && metaPair.short;
          var metaFull = metaPair && metaPair.full;

          var leaf = nav.querySelector('.pdp__crumb-leaf');
          if (!leaf) return;

          var inserts = [];
          if (vtLabel) {
            inserts.push(makeAnchor(vtLabel, '/?vt=' + encodeURIComponent(placement.vt)));
            inserts.push(makeSep());
          }
          if (metaShort) {
            inserts.push(makeSpan(metaShort));
            inserts.push(makeSep());
          }
          if (metaFull && metaFull !== metaShort) {
            inserts.push(makeSpan(metaFull));
            inserts.push(makeSep());
          }
          // Skip the sub crumb when it would duplicate the leaf (title === type),
          // which is common for products where merchants haven't given a more
          // specific title yet (e.g. plain "Üre AdBlue Deposu").
          var leafText = (leaf.textContent || '').trim().toLowerCase();
          var typeText = productType.toLowerCase();
          if (productType && leafText !== typeText) {
            inserts.push(makeSpan(productType));
            inserts.push(makeSep());
          }
          for (var i = 0; i < inserts.length; i++) nav.insertBefore(inserts[i], leaf);
        }

        getProductsData()
          .then(function (data) { render(findPlacement(data, handle)); })
          .catch(function () { /* fall back to base 3-crumb chain */ });
      })();

      // Thumbnail → main-image swap
      const thumbs = Array.from(document.querySelectorAll('[data-pdp-thumb]'));
      const mainImg = document.querySelector('[data-pdp-main-img]');
      function activateThumb(btn) {
        const src = btn.getAttribute('data-src');
        if (!src || !mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
        thumbs.forEach((b) => b.classList.toggle('is-active', b === btn));
      }
      thumbs.forEach((btn) => {
        btn.addEventListener('click', () => activateThumb(btn));
      });

      // Prev / next arrows on the main image — wrap around at the ends so the
      // user can keep clicking through. Only present when there are >1 images.
      function step(delta) {
        if (thumbs.length < 2) return;
        let i = thumbs.findIndex((b) => b.classList.contains('is-active'));
        if (i < 0) i = 0;
        const next = (i + delta + thumbs.length) % thumbs.length;
        activateThumb(thumbs[next]);
      }
      const prevBtn = document.querySelector('[data-pdp-prev]');
      const nextBtn = document.querySelector('[data-pdp-next]');
      if (prevBtn) prevBtn.addEventListener('click', () => step(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => step(1));

      // Variant selector → update the cart stepper's data-variant-id so add/remove hits the right variant
      const variantSel = document.querySelector('[data-pdp-variant-select]');
      const pdpCart = document.querySelector('[data-pdp-cart]');
      if (variantSel && pdpCart) {
        variantSel.addEventListener('change', () => {
          pdpCart.setAttribute('data-variant-id', variantSel.value);
          pdpCart.setAttribute('data-count', '0');
          const disp = pdpCart.querySelector('[data-count-display]');
          if (disp) disp.textContent = '';
          // Nudge the global stepper hydrator so count reflects the new variant's cart state
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('gt:pdp-variant-change'));
          }, 0);
        });
      }

      // Complementary products carousel — show arrows only when content
      // overflows horizontally; disable arrows at the start/end of scroll.
      const compViewport = document.querySelector('[data-pdp-comp-viewport]');
      const compNav = document.querySelector('[data-pdp-comp-nav]');
      const compPrev = document.querySelector('[data-pdp-comp-prev]');
      const compNext = document.querySelector('[data-pdp-comp-next]');
      if (compViewport && compNav && compPrev && compNext) {
        function compStep() {
          const card = compViewport.querySelector('.pcard');
          const styles = card ? getComputedStyle(card.parentElement) : null;
          const gap = styles ? parseFloat(styles.columnGap || styles.gap) || 0 : 0;
          return card ? card.getBoundingClientRect().width + gap : 200;
        }
        function compUpdate() {
          const overflow = compViewport.scrollWidth - compViewport.clientWidth > 4;
          compNav.toggleAttribute('hidden', !overflow);
          if (!overflow) return;
          const sl = compViewport.scrollLeft;
          const max = compViewport.scrollWidth - compViewport.clientWidth;
          compPrev.disabled = sl <= 2;
          compNext.disabled = sl >= max - 2;
        }
        compPrev.addEventListener('click', () => {
          compViewport.scrollBy({ left: -compStep(), behavior: 'smooth' });
        });
        compNext.addEventListener('click', () => {
          compViewport.scrollBy({ left: compStep(), behavior: 'smooth' });
        });
        compViewport.addEventListener('scroll', compUpdate, { passive: true });
        window.addEventListener('resize', compUpdate);
        // Initial check after layout settles (cards/images may not have width yet on DOMContentLoaded).
        requestAnimationFrame(compUpdate);
        setTimeout(compUpdate, 200);
      }

      // === Image lightbox ============================================
      // Click main gallery image → fullscreen modal with the high-res
      // version. Supports click-to-zoom toggle, mouse wheel zoom,
      // drag-to-pan when zoomed, two-finger pinch on touch, prev/next
      // (button + arrow keys), ESC and backdrop close.
      (function initLightbox() {
        const lightbox = document.querySelector('[data-pdp-lightbox]');
        const sourcesEl = document.querySelector('[data-pdp-lightbox-sources]');
        const mainImgEl = document.querySelector('[data-pdp-main-img]');
        if (!lightbox || !sourcesEl || !mainImgEl) return;

        let sources = [];
        try { sources = JSON.parse(sourcesEl.textContent) || []; } catch (_e) { sources = []; }
        if (!sources.length) return;

        const lbImg     = lightbox.querySelector('[data-pdp-lightbox-img]');
        const lbView    = lightbox.querySelector('[data-pdp-lightbox-viewport]');
        const closeBtn  = lightbox.querySelector('[data-pdp-lightbox-close]');
        const prevBtn   = lightbox.querySelector('[data-pdp-lightbox-prev]');
        const nextBtn   = lightbox.querySelector('[data-pdp-lightbox-next]');
        const thumbsLb  = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-thumb]'));

        let currentIdx = 0;
        let scale = 1, panX = 0, panY = 0;
        let isPanning = false, panStartX = 0, panStartY = 0;
        let pinchDist = 0, pinchScale = 1;
        let savedScrollY = 0;

        function applyTransform() {
          lbImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
        }
        function resetTransform() {
          scale = 1; panX = 0; panY = 0;
          lbImg.classList.remove('is-zoomed', 'is-panning');
          applyTransform();
        }
        function setIndex(idx) {
          currentIdx = ((idx % sources.length) + sources.length) % sources.length;
          const s = sources[currentIdx];
          if (!s) return;
          lbImg.src = s.src;
          lbImg.alt = s.alt || '';
          resetTransform();
        }
        function getMainIdx() {
          // Match the current main image to the sources list by URL fragment.
          const cur = (mainImgEl.currentSrc || mainImgEl.src || '').split('?')[0];
          for (let i = 0; i < sources.length; i++) {
            const candidate = (sources[i].src || '').split('?')[0];
            // Compare the file path component (Shopify CDN keeps the same path
            // across width variants).
            if (cur && candidate && cur.split('/').pop().split('.')[0] === candidate.split('/').pop().split('.')[0]) {
              return i;
            }
          }
          // Fallback: try the active thumb's index.
          const activeIdx = thumbsLb.findIndex((t) => t.classList.contains('is-active'));
          return activeIdx >= 0 ? activeIdx : 0;
        }
        function open(idx) {
          setIndex(idx);
          savedScrollY = window.scrollY;
          lightbox.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
          // Move focus into the modal for keyboard / screen reader users.
          (closeBtn || lbImg).focus({ preventScroll: true });
        }
        function close() {
          lightbox.setAttribute('hidden', '');
          document.body.style.overflow = '';
          resetTransform();
          // Restore focus to the gallery image.
          mainImgEl.focus({ preventScroll: true });
          window.scrollTo({ top: savedScrollY });
        }

        // Open on main image click.
        mainImgEl.addEventListener('click', function () { open(getMainIdx()); });
        mainImgEl.setAttribute('role', 'button');
        mainImgEl.setAttribute('tabindex', '0');
        mainImgEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(getMainIdx()); }
        });

        // Close interactions.
        if (closeBtn) closeBtn.addEventListener('click', close);
        lightbox.addEventListener('click', function (e) {
          // Click on the backdrop (anywhere that isn't the image or a button).
          if (e.target === lightbox || e.target === lbView) close();
        });
        document.addEventListener('keydown', function (e) {
          if (lightbox.hasAttribute('hidden')) return;
          if (e.key === 'Escape') { e.preventDefault(); close(); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); setIndex(currentIdx + 1); }
          else if (e.key === 'ArrowLeft')  { e.preventDefault(); setIndex(currentIdx - 1); }
        });

        if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); setIndex(currentIdx - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); setIndex(currentIdx + 1); });

        // Click image to toggle 1x ↔ 2.4x zoom.
        lbImg.addEventListener('click', function (e) {
          e.stopPropagation();
          if (isPanning) return;
          if (scale <= 1.05) {
            scale = 2.4;
            lbImg.classList.add('is-zoomed');
          } else {
            resetTransform();
          }
          applyTransform();
        });

        // Mouse wheel: smooth zoom, capped 1× – 5×.
        lbView.addEventListener('wheel', function (e) {
          if (lightbox.hasAttribute('hidden')) return;
          e.preventDefault();
          const delta = -e.deltaY * 0.0025;
          const newScale = Math.max(1, Math.min(5, scale + delta));
          scale = newScale;
          if (scale <= 1.01) {
            resetTransform();
          } else {
            lbImg.classList.add('is-zoomed');
            applyTransform();
          }
        }, { passive: false });

        // Drag to pan when zoomed in.
        lbImg.addEventListener('mousedown', function (e) {
          if (scale <= 1.05) return;
          isPanning = true;
          panStartX = e.clientX - panX;
          panStartY = e.clientY - panY;
          lbImg.classList.add('is-panning');
          e.preventDefault();
        });
        document.addEventListener('mousemove', function (e) {
          if (!isPanning) return;
          panX = e.clientX - panStartX;
          panY = e.clientY - panStartY;
          applyTransform();
        });
        document.addEventListener('mouseup', function () {
          if (!isPanning) return;
          isPanning = false;
          lbImg.classList.remove('is-panning');
        });

        // Touch: two-finger pinch zoom + one-finger swipe (when zoomed) to pan.
        lbImg.addEventListener('touchstart', function (e) {
          if (e.touches.length === 2) {
            const dx = e.touches[0].clientX - e.touches[1].clientX;
            const dy = e.touches[0].clientY - e.touches[1].clientY;
            pinchDist = Math.hypot(dx, dy);
            pinchScale = scale;
          } else if (e.touches.length === 1 && scale > 1.05) {
            isPanning = true;
            panStartX = e.touches[0].clientX - panX;
            panStartY = e.touches[0].clientY - panY;
          }
        }, { passive: true });
        lbImg.addEventListener('touchmove', function (e) {
          if (e.touches.length === 2 && pinchDist > 0) {
            e.preventDefault();
            const dx = e.touches[0].clientX - e.touches[1].clientX;
            const dy = e.touches[0].clientY - e.touches[1].clientY;
            const dist = Math.hypot(dx, dy);
            scale = Math.max(1, Math.min(5, pinchScale * (dist / pinchDist)));
            if (scale > 1.01) lbImg.classList.add('is-zoomed');
            applyTransform();
          } else if (isPanning && e.touches.length === 1) {
            e.preventDefault();
            panX = e.touches[0].clientX - panStartX;
            panY = e.touches[0].clientY - panStartY;
            applyTransform();
          }
        }, { passive: false });
        lbImg.addEventListener('touchend', function () {
          isPanning = false;
          pinchDist = 0;
          if (scale <= 1.01) resetTransform();
        }, { passive: true });
      })();
    } catch (err) {
      console.warn('product section init failed:', err);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
